require("./Proto.cjs");

import HTTPSender from "./HTTPSender";
import bus, { g_euroDate, g_UserSettings } from "../main";
import { Telemetry, TelemetrySchedule } from "./Telemetry";
import Translation from "./Translation";
let TR = Translation.lang;

const SHOW_DEBUG_MESSAGES = require("../../my_globals").SHOW_DEBUG_MESSAGES;
const dateFormat = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/;
const dateFormat2 = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}.\d{1,9}Z*$/;

let VAT_GROUPS = [];

export const chart_locales = [
  {
    name: "bg",
    options: {
      months: ["Януари", "Февруари", "Март", "Април", "Май", "Юни", "Юли", "Август", "Септември", "Октомври", "Ноември", "Декември"],
      shortMonths: ["Яну", "Фев", "Мар", "Апр", "Май", "Юни", "Юли", "Авг", "Сеп", "Окт", "Ное", "Дек"],
      days: ["Неделя", "Понеделник", "Вторник", "Сряда", "Четвъртък", "Петък", "Събота"],
      shortDays: ["Нед", "Пон", "Вт", "Ср", "Чет", "Пет", "Съб"],
      toolbar: {
        menu: "Изтегляне на изображение",
        exportToPNG: "Изтегляне в PNG формат",
        exportToSVG: "Изтегляне в SVG формат",
        exportToCSV: "Изтегляне в CSV формат",
        selection: "Избор",
        selectionZoom: "Режим на мащаб",
        zoomIn: "Увеличаване на мащаба",
        zoomOut: "Намаляване на мащаба",
        pan: "Режим на движение",
        reset: "Нулиране на мащаба",
      },
    },
  },
  {
    name: "ro",
    options: {
      months: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
      shortMonths: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Nu", "Dec"],
      days: ["Duminica", "Luni", "Marti", "Miercuri", "Joi", "Vineri", "Sambata"],
      shortDays: ["Dum", "Lun", "Mar", "Mie", "Joi", "Vin", "Sam"],
      toolbar: {
        menu: "Descarca",
        exportToPNG: "Descarca PNG",
        exportToSVG: "Descarca SVG",
        exportToCSV: "Descarca CSV",
        selection: "Alegere",
        selectionZoom: "Modul de scara",
        zoomIn: "A mari",
        zoomOut: "A micsora",
        pan: "Modul de miscare",
        reset: "Resetati scala",
      },
    },
  },
  {
    name: "md",
    options: {
      months: ["Ianuarie", "Februarie", "Martie", "Aprilie", "Mai", "Iunie", "Iulie", "August", "Septembrie", "Octombrie", "Noiembrie", "Decembrie"],
      shortMonths: ["Ian", "Feb", "Mar", "Apr", "Mai", "Iun", "Iul", "Aug", "Sep", "Oct", "Nu", "Dec"],
      days: ["Duminica", "Luni", "Marti", "Miercuri", "Joi", "Vineri", "Sambata"],
      shortDays: ["Dum", "Lun", "Mar", "Mie", "Joi", "Vin", "Sam"],
      toolbar: {
        menu: "Descarca",
        exportToPNG: "Descarca PNG",
        exportToSVG: "Descarca SVG",
        exportToCSV: "Descarca CSV",
        selection: "Alegere",
        selectionZoom: "Modul de scara",
        zoomIn: "A mari",
        zoomOut: "A micsora",
        pan: "Modul de miscare",
        reset: "Resetati scala",
      },
    },
  },
  {
    name: "en",
    options: {
      months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
      shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
      days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      toolbar: {
        menu: "Menu",
        DownloadSVG: "Download SVG",
        DownloadPNG: "Download PNG",
        DownloadCSV: "Download CSV",
        selection: "Selection",
        selectionZoom: "Selection Zoom",
        zoomIn: "Zoom In",
        zoomOut: "Zoom Out",
        pan: "Panning",
        reset: "Reset Zoom",
      },
    },
  },
];

export let DevStatus = {};

export let MessageTypes = {};

export let DataFilterType = {};

var rt = function (value, text, icon, isNegative) {
  return {
    Value: value,
    Text: text,
    Icon: icon,
    IsNegative: !!isNegative,
    toString: function () {
      return text;
    },
  };
};

export let ReceiptType = {};

let ReceiptTypeArray = [];

const vmc_event = Object.assign({}, require("@/assets/demo/fuvas_event.json"));

export class DataFilter {
  /**
   * @param {string} propname
   * @param {string} text
   * @param {DataFilterType} type
   * @param {DataPropType} proptype
   * @param {Array} vals
   * @param {boolean} cantBeNull
   * @memberof DataFilter
   */
  constructor(propname = null, text = null, type = null, proptype = null, vals = null, cantBeNull = false) {
    this.propname = propname;
    this.text = text;
    this.type = type;
    this.proptype = proptype;
    this.cantBeNull = cantBeNull;
    if (vals) this.vals = vals.slice();
    else this.vals = [];
  }

  toString() {
    var len = this.vals.length;
    if (this.type == DataFilterType.In || this.type == DataFilterType.WeekDays) {
      var txt = "";
      this.vals.forEach((e, idx) => {
        if (idx + 1 == len) txt += e;
        else txt += e + ", ";
      });
      return "'" + this.text + "'" + this.type.text + "[" + txt + "]";
    } else if (this.type == DataFilterType.Equals && this.proptype == DataPropType.BOOL) {
      return this.text + this.type.text + (this.vals[0] == true ? TR.Yes : TR.No);
    } else if (len == 1) {
      if (this.proptype == DataPropType.Date) {
        return "'" + this.text + "'" + this.type.text + this.vals[0].toTremolFpStringShort();
      } else {
        return "'" + this.text + "'" + this.type.text + this.vals[0];
      }
    } else if (len == 2) {
      if (this.proptype == DataPropType.Date) {
        return "'" + this.text + "'" + this.type.text + (this.vals[0] ? this.vals[0].toTremolFpStringShort() : "") + " и " + (this.vals[1] ? this.vals[1].toTremolFpStringShort() : "");
      } else {
        return "'" + this.text + "'" + this.type.text + this.vals[0] + " и " + this.vals[1];
      }
    } else if (this.text == null) {
      return TR.FilterNotChosen;
    } else return TR.FilterInvalidForField + " " + "'" + this.text + "'";
  }
}

export const DataPropType = Object.freeze({
  Number: "Number",
  WeekDays: "WeekDays",
  Date: "Date",
  DateShort: "DateShort",
  String: "String",
  Money: "Money",
  Money4digits: "Money4digits",
  QTY: "QTY",
  Month: "Month",
  BOOL: "Boolean",
  SaleType: "typeCode",
  None: "None",
});

export class DataHeader {
  /**
   *Creates an instance of Filter.
   * @param {string} text
   * @param {string} value
   * @param {DataPropType} proptype
   * @param {?string} cell_align
   * @param {?boolean} isHidden
   * @param {?boolean} summable
   * @param {?boolean} hideDivider
   * @param {?boolean} isNotInSelector
   */
  constructor(text, value, proptype, cell_align, isHidden, summable, hideDivider, isNotInSelector, isNotForClicking) {
    this.text = text;
    this.value = value;
    this.align = "center";
    this.summable = summable;
    this.canBeClicked = true;
    if (proptype) this.proptype = proptype;
    else this.proptype = DataManager.DataPropType.None;
    if (cell_align) this.cell_align = cell_align;
    else this.cell_align = "start";
    if (isHidden !== null && isHidden !== undefined) {
      this.hidden = isHidden;
    } else {
      this.hidden = false;
    }
    if (isNotInSelector == null && isNotInSelector === undefined) {
      this.isInSelector = true;
    } else {
      this.isInSelector = !isNotInSelector;
    }
    if (isNotForClicking != null && isNotForClicking != undefined) {
      this.canBeClicked = false;
    }
    this.divider = !hideDivider;

    switch (proptype) {
      case DataPropType.Date:
      case DataPropType.DateShort:
        this.sort = function (a, b) {
          return new Date(a) - new Date(b);
        };
        break;
      case DataPropType.Month:
        this.sort = function (a, b) {
          return DataManager.MonthNames.indexOf(a) - DataManager.MonthNames.indexOf(b);
        };
        break;
      case DataPropType.BOOL:
        this.sort = function (a, b) {
          return Number(a) - Number(b);
        };
        break;
      case DataPropType.Number:
      case DataPropType.QTY:
      case DataPropType.Money: //??
      case DataPropType.Money4digits: //??
        this.sort = function (a, b) {
          return a - b;
        };
        break;

      case DataPropType.SaleType:
        this.sort = function (a, b) {
          if (a.toString() < b.toString()) {
            return -1;
          }
          if (a.toString() > b.toString()) {
            return 1;
          }
          return 0;
        };
        break;

      case DataPropType.WeekDays:
      case DataPropType.String:
      default:
        this.sort = function (a, b) {
          if (a < b || a === undefined) {
            return -1;
          }
          if (a > b || b === undefined) {
            return 1;
          }
          return 0;
        };
        break;
    }
  }
}

export class ErrorMessage {
  /**
   * @param {Number} ErrorCode
   * @param {Number} HttpCode
   * @param {string} Message
   * @param {Array} ErrorDetails
   * @memberof ErrorMessage
   */
  constructor(errCode, httpCode, msg, errDetails) {
    this.ErrorCode = errCode;
    this.HttpCode = httpCode;
    this.Message = msg;
    this.ErrorDetails = errDetails;
  }

  toString = () => {
    var msg = this.Message + "\n";
    if (this.ErrorDetails) {
      this.ErrorDetails.forEach((d) => (msg += d.Description + "\n"));
    }
    return msg;
  };

  static ERROR_CODE_OK = 0;
  static ERROR_CODE_FAIL = -10001;
}

class DataManager {
  constructor() {
    DataManager.__load();
  }

  // static IIS_SERVER_URL = "https://router.tremol.bg:44333"; // TEST SERVER
  static IIS_SERVER_URL = "https://router.tremol.bg:44330"; // REAL SERVER
  // static IIS_SERVER_URL = "https://router.tremol.bg:44330";
  // static IIS_SERVER_URL = "https://router.tremol.bg:44334";
  //static RO_IIS_SERVER_URL = "https://router.tremol.bg:44334"; //TEST malyk laptop
  static RO_IIS_SERVER_URL = "https://router.tremol.bg:44335"; //REAL SERVER RO

  static devicesCountForBigUsers = 50;
  static devicesCountForVeryBigUsers = 500;
  static daysForRequestM = //(new Date().getTime() > g_euroDate.getTime()) ? DataManager.daysForRequestM = ((new Date().getTime() - g_euroDate.getTime()) / (1000 * 60 * 60 * 24)).roundTo(0):
    ((new Date().getTime() - new Date(new Date().getFullYear() - 5, 0, 1, 0, 0, 0).getTime()) / (1000 * 60 * 60 * 24)).roundTo(0); // две години

  static daysForRequestZ = new Date().getDate() < 3 ? 3 : new Date().getDate(); //31;

  static daysForRequestS = 1;

  static chunkSizeDefault = 1000;
  static chunkSizeForMInitial = 50;
  static chunkSizeForZInitial = 50;
  static chunkSizeForSInitial = 50;

  static chunkSizeForM = 100;
  static chunkSizeForZ = 25;
  static chunkSizeForS = 25;

  static sales_loaded = false;
  static monitorInterval = 300 * 1000; // 180 * 1000;
  static monitorFunction = null;

  static currentUser = null;
  static currentTechnician = null;
  static userType = null;
  static userHasTelemetry = false;

  static bus = bus;
  static ___demoMode = false;
  static ___isDemoDataGenerated = false;
  static ___isDemoDataGenerating = false;

  static UserTypes = Object.freeze({
    Observer: 1,
    Distributor: 2,
    Owner: 8,
    OwnerWithTelemetry: 16,
    OwnerWithXML: 32,
    All: 0xff,
  });
  // TODO main chart_locales
  static MonthNames = chart_locales[0].options.months;
  static MonthNamesShort = chart_locales[0].options.shortMonths;
  static WeekDaysShort = chart_locales[0].options.shortDays;
  static WeekDays = chart_locales[0].options.days;

  static userHasAccess(user) {
    return (user & this.userType) > 0;
  }

  /** @type {Object[]}  */
  static data = [];

  /** @type {Date[]}  */
  static data_is_loading = [];

  /** @type {Date[]}  */
  static date_downloaded_to = [];

  static device_last_online = {};
  static device_last_row = {};
  static device_daily_turnover = {};
  static device_weekly_turnover = {};
  static device_last_telemetry = {};
  static device_last_telemetry_manual = {};
  static device_last_telemetry_calculated = {};
  static device_with_z_report_3_days = {};

  /** @type {DataHeader[][]} */
  static headers = [];

  /** @type {DataHeader[][]} */
  static headersexpanded = [];

  /**  @type {DataFilter[][]} */
  static filters = [];

  /**  @type {DataFilter[][]} */
  static filters_predefined = [];

  /** @type {String[]}  */
  static props_for_sorting = [];

  /** @type {String[][]}  */
  static props_for_grouping = [];

  /** @type {String[][]}  */
  static props_for_summing = [];

  /** @type {String[][]}  */
  static props_for_summing_average = [];

  /** @type {String[][]}  */
  static prop_for_range_average = [];

  /** @type {ErrorMessage}  */
  static last_error = null;

  static DataType = {
    user: { id: 0, dataid: 0, name: "Данни за потребителя", url: DataManager.IIS_SERVER_URL, path: "/WebPms/Cosmos/Users/getCurrentCuser" },
    devices: { id: 1, dataid: 1, name: "Данни за ФУ", url: DataManager.IIS_SERVER_URL, path: "/WebPms/Cosmos/devices" },
    subscription_plans: { id: 2, dataid: 2, name: "Абонаментни планове", url: DataManager.IIS_SERVER_URL, path: "/WebPms/Cosmos/cdata/subscriptions" },
    clients: { id: 3, dataid: 3, name: "Данни за фирмите", url: DataManager.IIS_SERVER_URL, path: "/WebPms/Cosmos/cdata/clients" },
    monthly: {
      id: 4,
      dataid: 4,
      name: "Месечни отчети live",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "M",
      initial: true,
      num_from: null,
      load_days: DataManager.daysForRequestM,
      chunk_size: DataManager.chunkSizeForMInitial,
      append_data: true,
      require_choice: false,
    },
    daily: {
      id: 5,
      dataid: 5,
      name: "Дневни отчети live",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "Z",
      initial: true,
      load_days: DataManager.daysForRequestZ,
      chunk_size: DataManager.chunkSizeForZInitial,
      append_data: true,
      require_choice: true,
    },
    sales: {
      id: 6,
      dataid: 6,
      name: "Продажби live",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      initial: true,
      load_days: DataManager.daysForRequestS,
      chunk_size: DataManager.chunkSizeForSInitial,
      append_data: true,
      require_choice: true,
    },
    sales_by_articles: {
      id: 7,
      dataid: 7,
      name: "По артикули",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      chunk_size: DataManager.chunkSizeForS,
      require_choice: true,
    }, //expandedProp: "sales" },
    sales_by_article_price: {
      id: 8,
      dataid: 7,
      name: "По цени на артикули",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      chunk_size: DataManager.chunkSizeForS,
      require_choice: true,
    }, //expandedProp: "sales" },
    sales_by_hours_qty: {
      id: 9,
      dataid: 9,
      name: "Продадени количества по часове",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      chunk_size: DataManager.chunkSizeForS,
      require_choice: true,
    }, //expandedProp: "sales" },
    sales_by_hours_price: {
      id: 10,
      dataid: 10,
      name: "Оборот по часове",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      chunk_size: DataManager.chunkSizeForS,
      require_choice: true,
      datesFromTo: undefined,
    }, //expandedProp: "sales" },
    messages: {
      id: 11,
      dataid: 11,
      name: "Съобщения",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/users/GetMessages",
    },
    balance_charges: {
      id: 12,
      dataid: 12,
      name: "Таксуване",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/Balance/GetBalanceCharges",
    },
    balance_payments: {
      id: 13,
      dataid: 13,
      name: "Плащания от клиента",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/Balance/GetBalancePayments",
    },
    discounts: {
      id: 14,
      dataid: 14,
      name: "Отстъпки",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/Balance/GetDiscounts",
    },
    remove_code: {
      id: 15,
      dataid: 15,
      name: "Код за разкачане",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/Users/GetRemoveAccessCodeForClient",
    },
    distrib_users: {
      id: 16,
      dataid: 16,
      name: "Клиенти на дистрибутора",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/RFU/GetCosmosUsersForDistrib",
    },
    telemetry: {
      id: 17,
      dataid: 17,
      name: "Одит информация",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "T",
      initial: true,
      load_days: 1500,
      chunk_size: DataManager.chunkSizeDefault,
      append_data: true,
    }, //TODO "T"?
    telemetry_current: {
      id: 18,
      dataid: 18,
      name: "Одит текущо състояние",
      url: null,
    },
    monitor: {
      id: 19,
      dataid: 19,
      name: "Помпа",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/monitorActivity",
    },

    daily_reports: {
      id: 20,
      dataid: 20,
      name: "Дневни отчети",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "Z",
      chunk_size: DataManager.chunkSizeForZ,
      require_choice: true,
    },
    daily_reports_grouped: {
      id: 21,
      dataid: 21,
      name: "Дневни отчети за период",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "Z",
      chunk_size: DataManager.chunkSizeForZ,
      require_choice: true,
    },
    sales_reports: {
      id: 22,
      dataid: 22,
      name: "Продажби",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      chunk_size: DataManager.chunkSizeForS,
      require_choice: true,
    }, //expandedProp: "sales" },
    sales_last_only: {
      id: 23,
      dataid: 23,
      name: "Последен бон",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      LastOnly: true,
      initial: true,
    },
    sales_by_payments: {
      id: 24,
      dataid: 24,
      name: "По видове плащания",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      chunk_size: DataManager.chunkSizeForS,
      require_choice: true,
    }, //expandedProp: "sales" },
    invoices_reports: {
      id: 25,
      dataid: 25,
      name: "Фактури",
      url: DataManager.IIS_SERVER_URL,
      path: "/WebPms/Cosmos/devices/GetReports",
      access_type: "S",
      chunk_size: DataManager.chunkSizeForS,
      require_choice: true,
    }, //expandedProp: "sales" },
  };

  static __load() {
    if (TR.Locale != Translation.bg.Locale) {
      Object.keys(DataManager.DataType).forEach((k) => {
        DataManager.DataType[k].url = DataManager.RO_IIS_SERVER_URL;
      });

      DataManager.DataType.user.path = "/WebPms/GTA/login";
      DataManager.DataType.devices.path = "/WebPms/GTA/alldevices";
      DataManager.DataType.monthly.path = "/WebPms/GTA/getReports";
      DataManager.DataType.daily.path = "/WebPms/GTA/getReports";
      DataManager.DataType.sales.path = "/WebPms/GTA/getReports";
      DataManager.DataType.sales_by_articles.path = "/WebPms/GTA/getReports";
      DataManager.DataType.sales_by_article_price.path = "/WebPms/GTA/getReports";
      DataManager.DataType.sales_by_hours_qty.path = "/WebPms/GTA/getReports";
      DataManager.DataType.sales_by_hours_price.path = "/WebPms/GTA/getReports";
      DataManager.DataType.telemetry.path = "/WebPms/GTA/getReports";
      DataManager.DataType.daily_reports.path = "/WebPms/GTA/getReports";
      DataManager.DataType.daily_reports_grouped.path = "/WebPms/GTA/getReports";
      DataManager.DataType.sales_reports.path = "/WebPms/GTA/getReports";
      DataManager.DataType.sales_last_only.path = "/WebPms/GTA/getReports";
      DataManager.DataType.sales_by_payments.path = "/WebPms/GTA/getReports";
      DataManager.DataType.invoices_reports.path = "/WebPms/GTA/getReports";
    }

    DevStatus = {
      //Unknown: { Color: "#CCE2ED", Text: "Неизвестен", Icon: "mdi-cloud-question", Description: "Устройството е с неизвестен статус." },
      Online: {
        Color: "#2FAFF6",
        Text: Translation.lang.Online,
        Icon: "mdi-cellphone-wireless",
        Description: Translation.lang.StatusOnlineDescription,
      },
      Offline: {
        Color: "#FB8C00",
        Text: Translation.lang.Offline,
        Icon: "mdi-cellphone-off",
        Description: Translation.lang.StatusOfflineDescription,
      },
      Blocked: {
        Color: "#FF0000",
        Text: Translation.lang.Blocked,
        Icon: "mdi-alert",
        Description: Translation.lang.StatusBlockedDescription,
      },
      // FMFull: { Color: "#FF0000", Text: "Пълна ФП", Icon: "mdi-chip", Description: "ФУ с препълнена фискална памет. Необходима е смяна на ФП." },
      // FMNearFull: { Color: "#F7B33C", Text: "Почти пълна ФП", Icon: "mdi-chip", Description: "ФУ с препълнена фискална памет. Необходима е смяна на ФП." },
      NoSubscription: {
        Color: "#8A9090",
        Text: Translation.lang.NoSubscription,
        Icon: "mdi-cash-remove",
        Description: Translation.lang.NoSubscription,
      },
      NoProfile: {
        Color: "#8AA0A0",
        Text: Translation.lang.NoProfile,
        Icon: "mdi-cellphone-lock",
        Description: Translation.lang.StatusNoProfile,
      },
    };
    if (TR.Locale == Translation.bg.Locale) {
      DevStatus.OldDevice = {
        Color: "#a1a1a1",
        Text: "Стар модел",
        Icon: "mdi-cloud-off-outline",
        Description: "Стар модел ФУ, който не поддържа дистанционно отчитане.",
      };
    }

    MessageTypes = {
      //None: { Rank: 0, text: "", Color: ""},
      Other: { Rank: 3, text: (() => Translation.lang.MessageOther)(), Color: "#969CC9" },
      Info: { Rank: 1, text: (() => Translation.lang.Info)(), Color: "#48BBFB" },
      Important: { Rank: 5, text: (() => Translation.lang.Important)(), Color: "#11994c" },
      Warning: { Rank: 7, text: (() => Translation.lang.Warning)(), Color: "#FFBB00" },
      Urgent: { Rank: 9, text: (() => Translation.lang.Urgent)(), Color: "#FF553B" },
    };

    DataFilterType = {
      //Null: { id: -1, text: "" },
      Contains: { id: 0, text: " " + TR.Contains + " " },
      Equals: { id: 1, text: " = " },
      LessThan: { id: 2, text: " < " },
      MoreThan: { id: 3, text: " > " },
      Between: { id: 4, text: " " + TR.IsBetween + " " },
      In: { id: 5, text: " = " },
      WeekDays: { id: 6, text: " = " },
    };

    ReceiptType = {
      fiscalReceipt: rt(0x31, TR.FiscalReceipt, "mdi-cash-plus"),
      invoice: rt(0x32, TR.Invoice, "mdi-cash-plus"),
      zReport: rt(0x34, TR.DailyReport, "mdi-alpha-z-circle-outline"),
      rapo: rt(0x35, TR.MoneyInOut, "mdi-cash-refund"),
      info: rt(0x36, TR.InfoReceipt, "mdi-information-outline"),
      duplicate: rt(0x37, TR.Duplicate, "mdi-content-copy"),
      registration: rt(0x38, TR.FiscalizationReceipt, "mdi-cellphone-information"),
      storno: rt(0x39, TR.StornoReceipt, "mdi-cash-minus", true),
      creditNote: rt(0x3a, TR.CreditNode, "mdi-cash-minus", true),
      fuvasAction: rt("B".charCodeAt(0), TR.FUVASEvent, "mdi-shield-alert-outline"),
      fuvasButton: rt("P".charCodeAt(0), TR.FUVASButtonEvent, "mdi-light-switch"),
      status: rt("S".charCodeAt(0), TR.DeviceStatus, "mdi-cellphone-wireless"),
      telemetry: rt("T".charCodeAt(0), TR.AuditInfoAuto, "mdi-light-switch"),
      telemetry_manual: rt("t".charCodeAt(0), TR.AuditInfoManual, "mdi-light-switch"),
    };
    ReceiptTypeArray = Object.values(ReceiptType);

    var optz = chart_locales.find((c) => c.name == TR.Locale).options;
    this.MonthNames = optz.months;
    this.MonthNamesShort = optz.shortMonths;
    this.WeekDays = optz.days;
    this.WeekDaysShort = optz.shortDays;

    VAT_GROUPS = [];
    for (var i = 1; i <= TR.VAT_GROUP_COUNT; i++) {
      VAT_GROUPS.push(TR["VAT_GROUP_" + i]);
    }

    Object.keys(DataManager.DataType).forEach(() => {
      DataManager.date_downloaded_to.push(null);
      DataManager.data.push([]);
      DataManager.headers.push([]);
      DataManager.filters.push([]);
      DataManager.filters_predefined.push([]);
      DataManager.props_for_sorting.push([]);
      DataManager.props_for_grouping.push([]);
      DataManager.props_for_summing.push([]);
      DataManager.props_for_summing_average.push([]);
      DataManager.prop_for_range_average.push(null);
      DataManager.data_is_loading.push(false);
      DataManager.headersexpanded.push([]);
    });

    DataManager.headers[DataManager.DataType.user.id] = [
      new DataHeader("Потребител", "userName", DataPropType.String),
      new DataHeader(TR.Name, "firstName", DataPropType.String),
      new DataHeader("Фамилия", "lastName", DataPropType.String),
      new DataHeader(TR.EIK, "eik", DataPropType.String),
      new DataHeader("Одобрен", "approved", DataPropType.BOOL),
      new DataHeader("ФУВАС Администратор потребител", "isFuvasAdminExistingUser", DataPropType.BOOL),
    ];

    DataManager.headers[DataManager.DataType.devices.id] = [
      new DataHeader("№", "my_custom_number", DataPropType.Number, "center", false, false, false, true, true),
      new DataHeader(TR.Device, "Name", DataPropType.String),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.Model, "model.name", DataPropType.String),
      new DataHeader(TR.Status, "Status.Text", DataPropType.String),
    ];

    if (TR.Locale == Translation.bg.Locale) {
      DataManager.headers[DataManager.DataType.devices.id].push(
        new DataHeader(TR.Company, "client.orgName", DataPropType.String),
        new DataHeader(TR.EIK, "client.eik", DataPropType.String, "start", true),
        new DataHeader(TR.MOL, "client.mol", DataPropType.String, "start", true),
        new DataHeader(TR.PSName, "PSName", DataPropType.String, "start", true),
        new DataHeader(TR.Technician, "Technician", DataPropType.String, "start", true),
        //new DataHeader(TR.KLEN, "klen", DataPropType.String, "start", true),
        new DataHeader(TR.LastActivity, "lastTalkDate", DataPropType.Date, "start", true),
        new DataHeader(TR.ZReportReceived, "ZReportReceived", DataPropType.BOOL, "center", true),
        new DataHeader(TR.SubscriptionPlan, "duprofile.csubscriptionPlan.name", DataPropType.String, "center"),
        new DataHeader(TR.ContractTo, "currServContrExpDate", DataPropType.DateShort),
        new DataHeader(TR.ActiveSim, "sim.activatedMo", DataPropType.BOOL, "center", true),
        new DataHeader(TR.FDRID, "fdrid", DataPropType.String, "start", true),
        new DataHeader(TR.Settlement, "currentAddr.naselenoMiasto", DataPropType.String),
        new DataHeader(TR.Street, "currentAddr.ulica", DataPropType.String),
        new DataHeader(TR.Comment, "Comment", DataPropType.String, "start", true),
      );
    } else {
      DataManager.headers[DataManager.DataType.devices.id].push(
        new DataHeader(TR.Technician, "Technician", DataPropType.String, "start"),
        new DataHeader(TR.PSName, "PSName", DataPropType.String, "start"),
        new DataHeader(TR.Address, "Address", DataPropType.String),
      );
    }

    DataManager.headers[DataManager.DataType.subscription_plans.id] = [new DataHeader(TR.Name, "name", DataPropType.String), new DataHeader(TR.MonthlyPrice, "price", DataPropType.Number), new DataHeader(TR.Description, "desciption", DataPropType.String)];

    DataManager.headers[DataManager.DataType.daily_reports.id] = [
      new DataHeader("№", "my_custom_number", DataPropType.Number, "center", false, false, false, true, true),
      new DataHeader(TR.Device, "Device", DataPropType.String),
      new DataHeader(TR.Company, "Device.client.orgName", DataPropType.String, "start", true),
      new DataHeader(TR.CompanyEIK, "Device.client.eik", DataPropType.String, "start", true),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.DevComment, "Device.Comment", DataPropType.String, "start", true),
      new DataHeader(TR.KLEN, "klen", DataPropType.String, "start", true),
      new DataHeader(TR.ReportNumber, "num", DataPropType.Number, "end"),
      new DataHeader(TR.Date, "date", DataPropType.Date),
      new DataHeader(TR.DayFromTheWeek, "WeekDay", DataPropType.String, "start", true),
      new DataHeader(TR.ReceiptsCount, "rcpsCount", DataPropType.Number, "end", false, true),
      new DataHeader(TR.Turnover, "Sum", DataPropType.Money, "end", false, true),
      new DataHeader(TR.StornoTurnover, "SumStorno", DataPropType.Money, "end", false, true),
    ];
    for (var ddd = 0; ddd < TR.VAT_GROUP_COUNT; ddd++) {
      DataManager.headers[DataManager.DataType.daily_reports.id].push(new DataHeader(TR.Turnover + " * " + VAT_GROUPS[ddd], "Turnover" + VAT_GROUPS[ddd], DataPropType.Money, "end", true, true));
      DataManager.headers[DataManager.DataType.daily_reports.id].push(new DataHeader(TR.Storno + " * " + VAT_GROUPS[ddd], "StornoTurnover" + VAT_GROUPS[ddd], DataPropType.Money, "end", true, true));
    }
    if (TR.Locale == Translation.ro.Locale) {
      DataManager.headers[DataManager.DataType.daily_reports.id].push(new DataHeader("Trimis", "SentToNRA", DataPropType.String));
    }

    DataManager.headers[DataManager.DataType.daily_reports.id].push(new DataHeader(TR.InCash, "Payment1", DataPropType.Money, "end", false, true));
    DataManager.headers[DataManager.DataType.daily_reports.id].push(new DataHeader(TR.Card, "Payment2", DataPropType.Money, "end", false, true));

    DataManager.headers[DataManager.DataType.daily_reports_grouped.id] = [
      new DataHeader("№", "my_custom_number", DataPropType.Number, "center", false, false, false, true, true),
      new DataHeader(TR.Device, "Device", DataPropType.String),
      new DataHeader(TR.Company, "Device.client.orgName", DataPropType.String, "start", true),
      new DataHeader(TR.CompanyEIK, "Device.client.eik", DataPropType.String, "start", true),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.DevComment, "Device.Comment", DataPropType.String, "start", true),
      new DataHeader(TR.Date, "date", DataPropType.Date, "center", true, false, false, true, true),
      new DataHeader(TR.ReceiptsCount, "rcpsCount", DataPropType.Number, "end", false, true),
      new DataHeader(TR.Turnover, "Sum", DataPropType.Money, "end", false, true),
      new DataHeader(TR.StornoTurnover, "SumStorno", DataPropType.Money, "end", false, true),
    ];
    for (var dd = 0; dd < TR.VAT_GROUP_COUNT; dd++) {
      DataManager.headers[DataManager.DataType.daily_reports_grouped.id].push(new DataHeader(TR.Turnover + " * " + VAT_GROUPS[dd], "Turnover" + VAT_GROUPS[dd], DataPropType.Money, "end", true, true));
      DataManager.headers[DataManager.DataType.daily_reports_grouped.id].push(new DataHeader(TR.Storno + " * " + VAT_GROUPS[dd], "StornoTurnover" + VAT_GROUPS[dd], DataPropType.Money, "end", true, true));
    }

    DataManager.headers[DataManager.DataType.monthly.id] = [
      new DataHeader("№", "my_custom_number", DataPropType.Number, "center", false, false, false, true, true),
      new DataHeader(TR.Device, "Device", DataPropType.String),
      new DataHeader(TR.Company, "Device.client.orgName", DataPropType.String, "start", true),
      new DataHeader(TR.CompanyEIK, "Device.client.eik", DataPropType.String, "start", true),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.DevComment, "Device.Comment", DataPropType.String, "start", true),
      //new DataHeader(TR.Date, "date", DataPropType.Date, "start", true),
      //new DataHeader(TR.KLEN, "klen", DataPropType.String, "start", true),
      new DataHeader(TR.Year, "YY", DataPropType.Number, "end"),
      new DataHeader(TR.Month, "Month", DataPropType.Month, "center"),
      new DataHeader(TR.YearAndMonth, "MonthYY", DataPropType.String, "center", true),
      new DataHeader(TR.ReceiptsCount, "rcpsCount", DataPropType.Number, "end", false, true),
      new DataHeader(TR.Turnover, "Sum", DataPropType.Money, "end", false, true),
      new DataHeader(TR.StornoTurnover, "SumStorno", DataPropType.Money, "end", false, true),
    ];

    for (var mm = 0; mm < TR.VAT_GROUP_COUNT; mm++) {
      DataManager.headers[DataManager.DataType.monthly.id].push(new DataHeader(TR.Turnover + " * " + VAT_GROUPS[mm], "Turnover" + VAT_GROUPS[mm], DataPropType.Money, "end", true, true));
      DataManager.headers[DataManager.DataType.monthly.id].push(new DataHeader(TR.Storno + " * " + VAT_GROUPS[mm], "StornoTurnover" + VAT_GROUPS[mm], DataPropType.Money, "end", true, true));
    }

    DataManager.headers[DataManager.DataType.monthly.id].push(new DataHeader(TR.InCash, "Payment1", DataPropType.Money, "end", false, true));
    DataManager.headers[DataManager.DataType.monthly.id].push(new DataHeader(TR.Card, "Payment2", DataPropType.Money, "end", false, true));
    // if (TR.Locale == Translation.bg.Locale) {
    //   DataManager.headers[DataManager.DataType.monthly.id].push(new DataHeader(TR.Currency, "Currency", DataPropType.String, "end", false, true));
    // }

    DataManager.headers[DataManager.DataType.invoices_reports.id] = [
      new DataHeader("№", "my_custom_number", DataPropType.Number, "center", false, false, false, true, true),
      // { text: 'Dessert (100g serving)', align: 'start', sortable: false, value: 'name',  },
      // { text: 'Calories', value: 'calories', filter: value => { if (!this.calories) { return true } return value < parseInt(this.calories)  },
      new DataHeader(TR.Device, "Device", DataPropType.String),
      new DataHeader(TR.Company, "Device.client.orgName", DataPropType.String, "start", true),
      new DataHeader(TR.CompanyEIK, "Device.client.eik", DataPropType.String, "start", true),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.KLEN, "klen", DataPropType.String, "start", true),
      new DataHeader(TR.ZReport, "rcp.zrepNum", DataPropType.Number, "end"),
      new DataHeader(TR.ReceiptType, "ReceiptType", DataPropType.String),
      new DataHeader(TR.Voided, "rcp.void", DataPropType.BOOL, "center"),

      new DataHeader("Номер на фактура", "invoiceData.invNum", DataPropType.String),
      new DataHeader(TR.Date, "date", DataPropType.Date),
      new DataHeader("Получател", "invoiceData.clientCompanyName", DataPropType.String),
      new DataHeader("Получател ЕИК", "invoiceData.clientEik", DataPropType.String),
      new DataHeader("Получател ЗДДС номер", "invoiceData.zddsNum", DataPropType.String),
      new DataHeader("Купувач", "invoiceData.clientMOL", DataPropType.String),
      new DataHeader("Адрес на получател", "invoiceData.clientCompanyAddress", DataPropType.String),
      //new DataHeader("", "data-table-expand"), не работи!
    ];
    for (var vv = 0; vv < TR.VAT_GROUP_COUNT; vv++) {
      DataManager.headers[DataManager.DataType.invoices_reports.id].push(new DataHeader(TR.Turnover + " * " + VAT_GROUPS[vv], "Turnover" + VAT_GROUPS[vv], DataPropType.Money, "end", false, true));
      DataManager.headers[DataManager.DataType.invoices_reports.id].push(new DataHeader(TR.VAT + " * " + VAT_GROUPS[vv], "VAT" + VAT_GROUPS[vv], DataPropType.Money, "end", false, true));
    }

    DataManager.headers[DataManager.DataType.sales_reports.id] = [
      new DataHeader("№", "my_custom_number", DataPropType.Number, "center", false, false, false, true, true),
      // { text: 'Dessert (100g serving)', align: 'start', sortable: false, value: 'name',  },
      // { text: 'Calories', value: 'calories', filter: value => { if (!this.calories) { return true } return value < parseInt(this.calories)  },
      new DataHeader(TR.Device, "Device", DataPropType.String),
      new DataHeader(TR.Company, "Device.client.orgName", DataPropType.String, "start", true),
      new DataHeader(TR.CompanyEIK, "Device.client.eik", DataPropType.String, "start", true),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.KLEN, "klen", DataPropType.String, "start", true),
      new DataHeader(TR.DevComment, "Device.Comment", DataPropType.String, "start", true),
      new DataHeader(TR.ZReport, "rcp.zrepNum", DataPropType.Number, "end"),
      //new DataHeader("Отчет дата", "rcp.zrepDate" , DataPropType.Date),
      //new DataHeader(TR.ReceiptsCount, "RC" , DataPropType.Number, "end"),
      //new DataHeader("Отчет сума", "Sum" , DataPropType.Money, "end"),
      new DataHeader(TR.ReceiptType, "ReceiptType", DataPropType.String),
      new DataHeader(TR.Voided, "rcp.void", DataPropType.BOOL, "center"),
      new DataHeader(TR.ReceiptNumber, "rcp.rcpNum", DataPropType.Number, "end"),
      new DataHeader(TR.Date, "date", DataPropType.Date),
      new DataHeader(TR.Sum, "Sum", DataPropType.Money, "end", false, true),
      //new DataHeader("", "data-table-expand"), не работи!
    ];
    for (var v = 0; v < TR.VAT_GROUP_COUNT; v++) {
      DataManager.headers[DataManager.DataType.sales_reports.id].push(new DataHeader(TR.Turnover + " * " + VAT_GROUPS[v], "Turnover" + VAT_GROUPS[v], DataPropType.Money, "end", false, true));
      DataManager.headers[DataManager.DataType.sales_reports.id].push(new DataHeader(TR.VAT + " * " + VAT_GROUPS[v], "VAT" + VAT_GROUPS[v], DataPropType.Money, "end", false, true));
    }

    DataManager.headers[DataManager.DataType.sales_by_payments.id] = [
      new DataHeader(TR.Device, "Device", DataPropType.String),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.KLEN, "klen", DataPropType.String, "start", true),
      new DataHeader(TR.ReceiptType, "ReceiptType", DataPropType.String),
      new DataHeader(TR.Voided, "rcp.void", DataPropType.BOOL, "center"),
      new DataHeader(TR.ReceiptDate, "date", DataPropType.Date),
      new DataHeader(TR.PaymentType, "payments_payType", DataPropType.String),
      new DataHeader(TR.PaymentSum, "payments_sum", DataPropType.Money),
    ];

    DataManager.headers[DataManager.DataType.sales_by_articles.id] = [
      new DataHeader(TR.Device, "Device", DataPropType.String, "start", true, false, false, true),
      new DataHeader(TR.Company, "Device.client.orgName", DataPropType.String, "start", true, false, false, true),
      new DataHeader(TR.CompanyEIK, "Device.client.eik", DataPropType.String, "start", true, false, false, true),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true, false, false, true),
      new DataHeader(TR.SaleDate, "date", DataPropType.Date, "start", true, false, false, true),
      new DataHeader(TR.ReceiptType, "ReceiptType", DataPropType.String, "start", false, false, false, false, true),
      new DataHeader(TR.ItemName, "sales_name", DataPropType.String),
      new DataHeader(TR.TaxGroup, "sales_taxGr", DataPropType.String, "center"),
      // new DataHeader(TR.PriceForOne, "sales_price", DataPropType.Money, "end"),
      new DataHeader(TR.Quantity, "sales_qty", DataPropType.QTY, "end", false, true),
      // new DataHeader(TR.TotalTurnover, "sales_finalPrice", DataPropType.Money, "end", false, true), //finalPrice има бъг при войдиране на артикулите
      new DataHeader(TR.TotalTurnover, "sales_sum", DataPropType.Money, "end", false, true),

      //new DataHeader("", "data-table-expand"), не работи!
    ];

    DataManager.headers[DataManager.DataType.sales_by_article_price.id] = [
      new DataHeader(TR.Device, "Device", DataPropType.String, "start", true, false, false, true),
      new DataHeader(TR.Company, "Device.client.orgName", DataPropType.String, "start", true, false, false, true),
      new DataHeader(TR.CompanyEIK, "Device.client.eik", DataPropType.String, "start", true, false, false, true),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true, false, false, true),
      new DataHeader(TR.SaleDate, "date", DataPropType.Date, "start", true, false, false, true),
      new DataHeader(TR.ItemName, "sales_name", DataPropType.String),
      new DataHeader(TR.TaxGroup, "sales_taxGr", DataPropType.String, "center"),
      new DataHeader(TR.PriceForOne, "sales_price", DataPropType.Money, "end"),
      new DataHeader(TR.Quantity, "sales_qty", DataPropType.QTY, "end", false, true),
      //new DataHeader(TR.TotalTurnover, "sales_finalPrice", DataPropType.Money, "end", false, true),
      //new DataHeader("", "data-table-expand"), не работи!
    ];

    DataManager.headers[DataManager.DataType.sales_by_hours_qty.id] = [
      new DataHeader(TR.Device, "Device", DataPropType.String),
      new DataHeader(TR.PSName, "Device.PSName", DataPropType.String, "start", true),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.KLEN, "klen", DataPropType.String, "start", true),
      new DataHeader(TR.ReceiptType, "ReceiptType.Text", DataPropType.String),
      new DataHeader(TR.Hour, "HH", DataPropType.String),
      new DataHeader(TR.SalesCount, "ItemsCount", DataPropType.QTY, "end"),
      new DataHeader(TR.TotalTurnover, "Sum", DataPropType.Money, "end"),
      //new DataHeader("", "data-table-expand"), не работи!
    ];

    DataManager.headers[DataManager.DataType.telemetry_current.id] = [
      new DataHeader(TR.Device, "Name", DataPropType.String),
      new DataHeader(TR.SN, "sn", DataPropType.String),
      new DataHeader(TR.FMNum, "fm", DataPropType.String, "start", true),
      new DataHeader(TR.Company, "client.orgName", DataPropType.String, "start", true),
      new DataHeader(TR.EIK, "client.eik", DataPropType.String, "start", true),
      new DataHeader(TR.MOL, "client.mol", DataPropType.String, "start", true),
      new DataHeader(TR.PSName, "PSName", DataPropType.String, "start", true),
      new DataHeader(TR.MaintananceDays, "MaintenanceSchedule", DataPropType.WeekDays, "start", true),
      new DataHeader(TR.Technician, "Technician", DataPropType.String, "start", false),
      new DataHeader(TR.LastMaintanance, "LastTelemetryCalculated.DatePeriodStart", DataPropType.Date, "center"),
      new DataHeader(TR.AuditAuto, "LastTelemetryCalculated.Date", DataPropType.Date, "center"),
    ];
    DataManager.filters_predefined[DataManager.DataType.telemetry_current.id] = [
      new DataFilter("PSName", TR.PSName, DataFilterType.In, DataPropType.String),
      new DataFilter("MaintenanceSchedule", TR.MaintananceDays, DataFilterType.WeekDays, DataPropType.WeekDays),
      new DataFilter("Technician", TR.Technician, DataFilterType.In, DataPropType.String),
    ];
    DataManager.filters_predefined[DataManager.DataType.devices.id] = [
      new DataFilter("client.orgName", TR.Company, DataFilterType.In, DataPropType.String),
      new DataFilter("PSName", TR.PSName, DataFilterType.In, DataPropType.String),
      new DataFilter("Technician", TR.Technician, DataFilterType.In, DataPropType.String),
    ];

    DataManager.filters_predefined[DataManager.DataType.monthly.id] = [];
    if (TR.Locale == Translation.bg.Locale) {
      DataManager.filters_predefined[DataManager.DataType.monthly.id].push(new DataFilter("Currency", TR.Currency, DataFilterType.In, DataPropType.String, [TR.MoneyAbbreviation], true));
    }
    DataManager.filters_predefined[DataManager.DataType.monthly.id].push(new DataFilter("MonthYY", TR.YearAndMonth, DataFilterType.In, DataPropType.String), new DataFilter("Device", TR.Device, DataFilterType.In, DataPropType.String));

    DataManager.filters_predefined[DataManager.DataType.daily_reports.id] = [new DataFilter("date", "Дата на отчета", DataFilterType.Between, DataPropType.Date), new DataFilter("Device", TR.Device, DataFilterType.In, DataPropType.String)];

    DataManager.filters_predefined[DataManager.DataType.daily_reports_grouped.id] = [
      // new DataFilter("date", "Период", DataFilterType.Between, DataPropType.Date),
      new DataFilter("Device", TR.Device, DataFilterType.In, DataPropType.String),
    ];
    DataManager.filters_predefined[DataManager.DataType.sales_reports.id] = [
      // new DataFilter("date", "Дата на бона", DataFilterType.Between, DataPropType.Date),
      new DataFilter("Device", TR.Device, DataFilterType.In, DataPropType.String),
      new DataFilter("ReceiptType", TR.ReceiptType, DataFilterType.In, DataPropType.String),
    ];
    DataManager.filters_predefined[DataManager.DataType.sales_by_articles.id] = [
      // new DataFilter("date", "Период", DataFilterType.Between, DataPropType.Date),
      new DataFilter("Device", TR.Device, DataFilterType.In, DataPropType.String),
      new DataFilter("ReceiptType", TR.ReceiptType, DataFilterType.In, DataPropType.String),
    ];
    DataManager.filters_predefined[DataManager.DataType.sales_by_article_price.id] = [
      // new DataFilter("date", "Период", DataFilterType.Between, DataPropType.Date),
      new DataFilter("Device", TR.Device, DataFilterType.In, DataPropType.String),
      // new DataFilter("sales_price", "Цена на артикул", DataFilterType.In, DataPropType.Number),
    ];
    DataManager.filters_predefined[DataManager.DataType.sales_by_hours_qty.id] = [
      // new DataFilter("date", "Период", DataFilterType.Between, DataPropType.Date),
      new DataFilter("Device", TR.Device, DataFilterType.In, DataPropType.String),
    ];

    DataManager.props_for_summing[DataManager.DataType.daily_reports_grouped.id] = ["rcpsCount", "Sum", "SumStorno"];
    for (var ff = 0; ff < TR.VAT_GROUP_COUNT; ff++) {
      DataManager.props_for_summing[DataManager.DataType.daily_reports_grouped.id].push("Turnover" + VAT_GROUPS[ff]);
      if (TR.Locale == Translation.bg.Locale) {
        DataManager.props_for_summing[DataManager.DataType.daily_reports_grouped.id].push("StornoTurnover" + VAT_GROUPS[ff]);
      }
    }

    DataManager.props_for_grouping[DataManager.DataType.daily_reports_grouped.id] = ["sn", "fm"];

    DataManager.props_for_summing[DataManager.DataType.sales_by_payments.id] = ["payments_sum"];
    DataManager.props_for_grouping[DataManager.DataType.sales_by_payments.id] = ["payments_payType", "date", "sn", "ReceiptType.Text", "rcp.void"];
    DataManager.props_for_sorting[DataManager.DataType.sales_by_payments.id] = "date";

    // DataManager.props_for_summing[DataManager.DataType.sales_by_articles.id] = ["sales_qty", "sales_finalPrice"];
    // DataManager.props_for_grouping[DataManager.DataType.sales_by_articles.id] = ["ReceiptType", "sales_name", "sales_taxGr"];
    // DataManager.props_for_sorting[DataManager.DataType.sales_by_articles.id] = "sales_finalPrice";
    DataManager.props_for_summing[DataManager.DataType.sales_by_articles.id] = ["sales_qty", "sales_sum"];
    DataManager.props_for_grouping[DataManager.DataType.sales_by_articles.id] = ["ReceiptType", "sales_name", "sales_taxGr"];
    DataManager.props_for_sorting[DataManager.DataType.sales_by_articles.id] = "sales_sum";

    DataManager.props_for_summing[DataManager.DataType.sales_by_article_price.id] = ["sales_qty"];
    DataManager.props_for_grouping[DataManager.DataType.sales_by_article_price.id] = ["ReceiptType", "sales_name", "sales_taxGr", "sales_price"];
    //DataManager.props_for_sorting[DataManager.DataType.sales_by_article_price.id] = "sales_finalPrice";

    DataManager.prop_for_range_average[DataManager.DataType.sales_by_hours_qty.id] = "rcp.date";
    DataManager.props_for_summing_average[DataManager.DataType.sales_by_hours_qty.id] = ["ItemsCount", "Sum"];
    DataManager.props_for_grouping[DataManager.DataType.sales_by_hours_qty.id] = ["ReceiptType", "sn", "HH"];
    DataManager.props_for_sorting[DataManager.DataType.sales_by_hours_qty.id] = "HH";

    DataManager.prop_for_range_average[DataManager.DataType.sales_by_hours_price.id] = "rcp.date";
    DataManager.props_for_summing_average[DataManager.DataType.sales_by_hours_price.id] = ["ItemsCount", "Sum"];
    DataManager.props_for_grouping[DataManager.DataType.sales_by_hours_price.id] = ["ReceiptType", "sn", "HH"];
    DataManager.props_for_sorting[DataManager.DataType.sales_by_hours_price.id] = "HH";
  }

  static __clean() {
    HTTPSender.AbortAll();
    if (DataManager.monitorFunction) {
      clearInterval(DataManager.monitorFunction);
      DataManager.monitorFunction = null;
    }
    DataManager.data.splice(0, DataManager.data.length);
    DataManager.headers.splice(0, DataManager.headers.length);
    DataManager.filters.splice(0, DataManager.filters.length);
    DataManager.filters_predefined.splice(0, DataManager.filters_predefined.length);
    DataManager.props_for_sorting.splice(0, DataManager.props_for_sorting.length);
    DataManager.props_for_grouping.splice(0, DataManager.props_for_grouping.length);
    DataManager.props_for_summing.splice(0, DataManager.props_for_summing.length);
    DataManager.props_for_summing_average.splice(0, DataManager.props_for_summing_average.length);
    DataManager.prop_for_range_average.splice(0, DataManager.prop_for_range_average.length);
    DataManager.date_downloaded_to.splice(0, DataManager.date_downloaded_to.length);
    DataManager.data_is_loading.splice(0, DataManager.data_is_loading.length);
    DataManager.currentUser = null;
    DataManager.userType = null;
    DataManager.userHasTelemetry = false;
    DataManager.___isDemoDataGenerated = false;
    TR = Translation.lang;
    DataManager.__load();
  }

  // static groupSumSort(datatype) {
  //   return DataManager.data[datatype.id]
  //     .filter((d) => ((DataManager.currentUser && (datatype.id == DataManager.DataType.devices.id || datatype.access_type)) ? (datatype.id == DataManager.DataType.devices.id ? d.client.eik == DataManager.currentUser.eik : false) || (datatype.access_type ? d.Device.client.eik == DataManager.currentUser.eik : false) : true))
  //     .groupByAndSum(DataManager.props_for_summing[datatype.id], ...DataManager.props_for_grouping[datatype.id])
  //     .groupByAndAverageSum(DataManager.props_for_summing_average[datatype.id], DataManager.prop_for_range_average[datatype.id], ...DataManager.props_for_grouping[datatype.id])
  //     .sortBy(DataManager.props_for_sorting[datatype.id]);
  // }

  static appendFilter(datatype, filter) {
    // console.log("DataManager fppend filter")
    // console.log(JSON.stringify(filter))

    if (!DataManager.filters[datatype.id]) {
      DataManager.filters[datatype.id] = [];
    }
    var filIdx = DataManager.filters[datatype.id].findIndex((f) => f.propname == filter.propname);
    if (filIdx == -1) {
      DataManager.filters[datatype.id].push(filter);
    } else if (!filter.vals || filter.vals.length == 0 || filter.vals[0] == undefined || filter.vals[0] == null) {
      DataManager.filters[datatype.id].splice(filIdx, 1);
    } else if (filter.vals.length > 0 && filter.vals[0] != null && filter.vals[0] != undefined) {
      DataManager.filters[datatype.id][filIdx].vals = filter.vals;
      //DataManager.filters[datatype.id][filIdx] = filter;
    }
    bus.$emit(bus.EVENT_DataManager_FILTERS_CHANGED, datatype);

    // if (!DataManager.filters[datatype.id]) {
    //   DataManager.filters[datatype.id] = [];
    // }
    // var filIdx = DataManager.filters[datatype.id].findIndex((f) => f.propname == filter.propname);
    // if (filter.vals.length == 0 || (filter.vals.length > 0 && filter.vals[0] == null)) {
    //   DataManager.filters[datatype.id].splice(filIdx, 1);
    // } else if (filter.vals.length > 0 && filter.vals[0] != null && filter.vals[0] != undefined) {
    //   if (filIdx == -1) {
    //     DataManager.filters[datatype.id].push(filter);
    //   } else {
    //     // DataManager.filters[datatype.id][filIdx].vals = [];
    //     DataManager.filters[datatype.id][filIdx].vals = filter.vals;
    //     //DataManager.filters[datatype.id][filIdx] = filter;
    //   }
    // }
    // bus.$emit(bus.EVENT_DataManager_FILTERS_CHANGED, datatype);
  }

  static removeFilter(datatype, filter) {
    if (!DataManager.filters[datatype.id]) {
      DataManager.filters[datatype.id] = [];
    }
    var filIdx = DataManager.filters[datatype.id].findIndex((f) => f.propname == filter.propname);
    if (filIdx != -1) {
      DataManager.filters[datatype.id].splice(filIdx, 1);
    }

    bus.$emit(bus.EVENT_DataManager_FILTERS_CHANGED, datatype);
  }

  /**
   * @param {Object} datatype
   * @param {DataFilter[]} filtrz
   */
  static setFilters(datatype, filtrz) {
    if (DataManager.filters[datatype.id]) {
      DataManager.filters[datatype.id].length = 0;
    } else {
      DataManager.filters[datatype.id] = [];
    }
    //DataManager.filters[datatype.id].push(...filtrz);
    DataManager.filters[datatype.id].push(...filtrz.filter((f) => f.propname && f.proptype && f.vals[0]));

    // DataManager.filters[datatype.id].every(function (f) {
    //     if (f.proptype == DataPropType.Date) {
    //         f.vals.every(v => {
    //             if (v instanceof String) {
    //                 try {
    //                     v = new Date(v);
    //                 } catch {
    //                     v = v.parseDateWithFormat("yyyy-MM-dd");
    //                 }
    //             }
    //             console.log(v);
    //         });
    //     }
    // });
    bus.$emit(bus.EVENT_DataManager_FILTERS_CHANGED, datatype);
  }

  /**
   *
   * @param {DataType.id} datatypeId DataType.id
   * @return {DataFilter[]}
   */
  static getFilters(datatypeId) {
    return DataManager.filters[datatypeId];
  }

  static getFilterLines(datatypeId) {
    var res = [];
    DataManager.filters[datatypeId].forEach((f) => {
      res.push(f.toString());
    });
    return res;
  }

  static getFilterDistinctValues(datatype, filter) {
    if (filter.type == DataFilterType.WeekDays) {
      return DataManager.WeekDays.slice(0, DataManager.WeekDays.length);
    } else {
      return DataManager.data[datatype.dataid]
        .filter((o) => Object.byString(o, filter.propname))
        .map((p) => Object.byString(p, filter.propname).toString())
        .unique();
    }
  }

  static getFilterDistinctValuesByName(datatype, propname) {
    return DataManager.getData(datatype)
      .filter((d) => (datatype == DataManager.DataType.devices ? d.IsForMe : true))
      .filter((o) => Object.byString(o, propname))
      .map((p) => Object.byString(p, propname).toString())
      .unique();
  }

  static getFilterTypesByPropType(propType) {
    if (!propType) return Object.values(DataFilterType);
    switch (propType) {
      case DataPropType.BOOL:
        return Object.values({ Equals: DataFilterType.Equals });
      case DataPropType.Date:
      case DataPropType.DateShort:
        return Object.values({
          Equals: DataFilterType.Equals,
          LessThan: DataFilterType.LessThan,
          MoreThan: DataFilterType.MoreThan,
          Between: DataFilterType.Between,
        });
      case DataPropType.Money:
      case DataPropType.QTY:
      case DataPropType.Number:
        return Object.values({
          Equals: DataFilterType.Equals,
          LessThan: DataFilterType.LessThan,
          MoreThan: DataFilterType.MoreThan,
          Between: DataFilterType.Between,
          Contains: DataFilterType.Contains,
        });
      case DataPropType.SaleType:
        return Object.values({
          In: DataFilterType.In,
          Contains: DataFilterType.Contains,
          Equals: DataFilterType.Equals,
        });
      case DataPropType.Month:
      case DataPropType.String:
        return Object.values({
          Contains: DataFilterType.Contains,
          In: DataFilterType.In,
          Equals: DataFilterType.Equals,
        });
      case DataPropType.WeekDays:
        return Object.values({
          WeekDay: DataFilterType.WeekDays,
        });
    }
  }

  /**
   *
   * @param {DataType} datatype DataType
   * @return {DataHeader[]}
   */
  static getHeaders(datatype) {
    return DataManager.headers[datatype.id];
  }

  /**
   *
   * @param {DataType} datatype DataType.id
   * @return {DataHeader[]}
   */
  static getHeadersExpanded(datatype) {
    return DataManager.headersexpanded[datatype.id];
  }

  static isBigUser() {
    return DataManager.getSubscribedDevs(true).length > DataManager.devicesCountForBigUsers;
  }

  static isVeryBigUser() {
    return DataManager.getSubscribedDevs(true).length > DataManager.devicesCountForVeryBigUsers;
  }

  static getSubscribedDevs(notFiltered) {
    if (TR.Locale == Translation.bg.Locale) {
      return DataManager.getData(DataManager.DataType.devices, notFiltered).filter((d) => d.IsSubscribed);
    } else {
      return DataManager.getData(DataManager.DataType.devices, notFiltered).filter((d) => d.IsForMe);
    }
  }

  /**
   *
   * @param {DataType} id DataType
   * @param {Boolean} notFiltered true for not filtered data
   */
  static getData(datatype, notFiltered) {
    var fltrz = DataManager.filters[datatype.id];
    var data = DataManager.data[datatype.dataid];
    // console.log(g_UserSettings.hideOldModels)
    if (g_UserSettings.hideOldModels) {
      if (datatype == DataManager.DataType.devices) {
        data = data.filter((d) => d.duprofile && d.duprofile.cosmosableDevice);
      } else if (data[0] && data[0].Device) {
        data = data.filter((d) => d.Device.duprofile && d.Device.duprofile.cosmosableDevice);
      }
    }
    if (notFiltered || !fltrz || fltrz.length == 0 || !(DataManager.data[datatype.dataid] instanceof Array)) {
      return DataManager.data[datatype.dataid] instanceof Array
        ? data
            .filter((d) => DataManager._filterFnCurrentTechnician(datatype, d))
            .filter((d) => DataManager._filterFnCurrentUser(datatype, d))
            .groupByAndSum(DataManager.props_for_summing[datatype.id], ...DataManager.props_for_grouping[datatype.id])
            .groupByAndAverageSum(DataManager.props_for_summing_average[datatype.id], DataManager.prop_for_range_average[datatype.id], ...DataManager.props_for_grouping[datatype.id])
            // .sortBy(DataManager.props_for_sorting[datatype.id])
            .sortByDesc(DataManager.props_for_sorting[datatype.id])
        : data;
    }

    // if (DataManager.currentUser == null) {
    //   data = DataManager.data[dataid];
    // } else {
    //   if () {
    //     data = DataManager.data[dataid].filter((d) => d.client.eik == DataManager.currentUser.eik);
    //   } else if ([DataManager.DataType.monthly.id, DataManager.DataType.daily.id, DataManager.DataType.sales.id, DataManager.DataType.sales_by_articles.id, DataManager.DataType.sales_by_hours_qty.id, DataManager.DataType.sales_by_payments.id].indexOf(id) != -1) {
    //     data = DataManager.data[dataid].filter((d) => d.Device.client.eik == DataManager.currentUser.eik);
    //   } else {
    //     data = DataManager.data[dataid];
    //   }
    // }

    var fltrzNotSumming = fltrz.filter((f) => DataManager.props_for_summing[datatype.id].indexOf(f.propname) == -1 && DataManager.props_for_summing_average[datatype.id].indexOf(f.propname) == -1);
    var fltrzSumming = fltrz.filter((f) => DataManager.props_for_summing[datatype.id].indexOf(f.propname) != -1 || DataManager.props_for_summing_average[datatype.id].indexOf(f.propname) != -1);
    return (
      data
        .filter((d) => DataManager._filterFnCurrentTechnician(datatype, d))
        .filter((d) => DataManager._filterFnCurrentUser(datatype, d))
        .filter((i) => DataManager._filterFn(fltrzNotSumming, i))
        .groupByAndSum(DataManager.props_for_summing[datatype.id], ...DataManager.props_for_grouping[datatype.id])
        .groupByAndAverageSum(DataManager.props_for_summing_average[datatype.id], DataManager.prop_for_range_average[datatype.id], ...DataManager.props_for_grouping[datatype.id])
        .filter((i) => DataManager._filterFn(fltrzSumming, i))
        // .map((item, index) => ({
        //   my_custom_id: index,
        //   ...item,
        // }))
        .sortBy(DataManager.props_for_sorting[datatype.id])
    ); //TODO;
  }

  static _filterFn(fltrz, i) {
    return fltrz.every((f) => {
      if (f.vals == null || f.vals === undefined) return !(f.type || f.propname); //return false;
      var propVal = Object.byString(i, f.propname);
      switch (f.type) {
        case DataFilterType.Equals:
          if (f.proptype == DataPropType.Date || f.proptype == DataPropType.DateShort) return propVal && propVal.getDateWithoutTime().getTime() == f.vals[0].getDateWithoutTime().getTime();
          else return propVal == f.vals[0]; //return f.vals.indexOf(i[f.propname]) !== -1;
        case DataFilterType.Contains:
          return propVal.toString().toLowerCase().indexOf(f.vals[0].toLowerCase()) !== -1; //return f.vals.some(function(v){ return i[f.prop].toString().indexOf(v) !== -1})
        case DataFilterType.Between:
          if (f.proptype == DataPropType.Date || f.proptype == DataPropType.DateShort) return propVal && f.vals[0].getDateWithoutTime().getTime() <= propVal.getTime() && f.vals[1].getTime() >= propVal.getTime();
          else return propVal >= f.vals[0] && propVal <= f.vals[1];
        case DataFilterType.LessThan:
          return propVal <= f.vals[0];
        case DataFilterType.MoreThan:
          return propVal >= f.vals[0];
        case DataFilterType.In:
          return propVal && f.vals.indexOf(propVal.toString()) !== -1;
        case DataFilterType.WeekDays: {
          return propVal && Object.values(propVal).some((pv) => f.vals.indexOf(pv.toString()) !== -1);
        }
        default:
          return false;
      }
    });
  }

  static _filterFnCurrentTechnician(datatype, d) {
    if (DataManager.currentTechnician) {
      if (datatype.access_type) {
        return DataManager.currentTechnician == d.Device.Technician;
      }
      // else if (datatype.id == DataManager.DataType.devices.id) {
      //   return DataManager.currentTechnician == d.Technician;
      // }
    }
    return true;
  }

  static _filterFnCurrentUser(datatype, d) {
    return DataManager.currentUser && (datatype.id == DataManager.DataType.devices.id || datatype.access_type) //devices or S Z M
      ? (datatype.id == DataManager.DataType.devices.id ? d.client.eik == DataManager.currentUser.eik : false) || (datatype.access_type ? d.Device.client.eik == DataManager.currentUser.eik : false)
      : true;
  }

  static formatGridData(type, value) {
    if (value === undefined) {
      return "";
    }
    if (type == DataPropType.Date && value) {
      return value.toTremolFpString();
    } else if (type == DataPropType.DateShort && value) {
      return value.toTremolFpStringShort();
    } else if (type == DataPropType.Money) {
      return value !== undefined ? value.toFixed(2) : "";
    } else if (type == DataPropType.Money4digits) {
      return value.toFixed(4);
    } else if (type == DataPropType.QTY) {
      return value.toFixed(3);
    } else if (type == DataPropType.SaleType) {
      if (value == 49) return TR.Article;
      if (value == 50) return TR.Department;
      return value;
    } else if (type == DataPropType.BOOL) {
      if (value == true) return TR.Yes;
      else return TR.No;
    } else if (type == DataPropType.String && value) {
      return value.toString();
    }
    // else if (type == DataPropType.Month) { //вече е стринг с къстъм сорт
    //     return DataManager.MonthNames[value - 1];
    // }
    else {
      return value;
    }
  }

  /**
   *
   * @param {string} username
   * @param {string} password
   * @param {function(ErrorMessage)} callback
   */
  static login(username, password, callback) {
    if (username.toLowerCase() == "demo" || username.toLowerCase() == "демо" || username.toLowerCase() == "счетоводител") {
      setTimeout(async () => {
        DataManager.___demoMode = true;
        if (TR.Locale == Translation.bg.Locale) {
          if (username.toLowerCase() == "счетоводител") {
            DataManager.userType = DataManager.UserTypes.Observer;
            await DataManager.__analyzeData(require("@/assets/demo/user_observer.json"), DataManager.DataType.user, false, null);
          } else {
            DataManager.userType = DataManager.UserTypes.Owner;
            await DataManager.__analyzeData(require("@/assets/demo/user.json"), DataManager.DataType.user, false, null);
          }
          DataManager.data[DataManager.DataType.clients.dataid] = require("@/assets/demo/clients.json");
          DataManager.data[DataManager.DataType.subscription_plans.dataid] = require("@/assets/demo/subscription_plans.json");
          DataManager.data[DataManager.DataType.messages.dataid] = require("@/assets/demo/incoming_messages.json");
          DataManager.data[DataManager.DataType.discounts.dataid] = require("@/assets/demo/discounts.json");
          await DataManager.__fixData(DataManager.DataType.messages);
          DataManager.data[DataManager.DataType.balance_payments.dataid] = JSON.parse(JSON.stringify(require("@/assets/demo/balance_payments.json")), reviver);
          const bch = require("@/assets/demo/balance_charges.json")[0];
          const dayz = 60;
          const paymentz = DataManager.data[DataManager.DataType.balance_payments.dataid];
          DataManager.data[DataManager.DataType.user.dataid].balance = (paymentz.map((a) => a.amount).sum() - bch.amountCharged * dayz).roundTo(2);
          const start = new Date().getDateWithoutTime().addDays(-dayz);
          for (var i = 0; i < dayz; i++) {
            var bc = Object.assign({}, bch);
            bc.date = start.addDays(i);
            bc.devDayChargeEntries.forEach((c) => (c.date = bc.date));
            Object.freeze(bc);
            DataManager.data[DataManager.DataType.balance_charges.dataid].push(bc);
          }
        } else {
          //if (TR.Locale == Translation.ro.Locale) {
          if (username.toLowerCase() == "contabil") {
            DataManager.userType = DataManager.UserTypes.Observer;
            await DataManager.__analyzeData(require("@/assets/demoro/user_observer.json"), DataManager.DataType.user, false, null);
          } else {
            DataManager.userType = DataManager.UserTypes.Owner;
            await DataManager.__analyzeData(require("@/assets/demoro/user.json"), DataManager.DataType.user, false, null);
          }
          DataManager.data[DataManager.DataType.clients.dataid] = require("@/assets/demoro/clients.json");
        }

        DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
        await DataManager.reloadDeviceData(callback);
      }, 20);
    } else {
      DataManager.___demoMode = false;
      DataManager.data[DataManager.DataType.user.dataid] = null;
      DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
      if (TR.Locale == Translation.bg.Locale) {
        HTTPSender.SendPOSTreq(JSON.stringify({ username: username, password: password }), DataManager.IIS_SERVER_URL, "/WebPms/Cosmos/users/login")
          .done(async (resp) => {
            if (await DataManager.__analyzeData(resp, DataManager.DataType.user, false, null)) {
              DataManager.loadData(
                DataManager.DataType.subscription_plans,
                () => {
                  DataManager.loadData(DataManager.DataType.discounts, () => {
                    DataManager.loadData(DataManager.DataType.messages, async () => {
                      await DataManager.reloadDeviceData(callback, true);
                      DataManager.__startMonitor();
                    });
                  });
                },
                true,
              );
            } else {
              if (callback) callback(DataManager.last_error);
            }
          })
          .fail((xhr, textStatus, errorThrown) => {
            DataManager.__analyzeFail(xhr, DataManager.DataType.user, callback, textStatus, errorThrown);
          });
      } else {
        HTTPSender.SendPOSTreq(JSON.stringify({ username: username, password: password }), DataManager.RO_IIS_SERVER_URL, "/WebPms/GTA/login")
          .done(async (resp) => {
            if (await DataManager.__analyzeData(resp, DataManager.DataType.user, false, null)) {
              await DataManager.reloadDeviceData(callback, true);
            } else {
              if (callback) callback(DataManager.last_error);
            }
          })
          .fail((xhr, textStatus, errorThrown) => {
            DataManager.__analyzeFail(xhr, DataManager.DataType.user, callback, textStatus, errorThrown);
          });
      }
    }
  }

  /**
   *
   * @param {*} observerData
   * @param {function(ErrorMessage)} callback
   */
  static updateUserObserver(observerData, callback) {
    DataManager.__sendSimpleReq(observerData, "/WebPms/Cosmos/Users/giveAccessToObserverCUser", callback);
  }

  /**
   *
   * @param {*} invoiceData
   * @param {function(ErrorMessage)} callback
   */
  static updateUserSignedDeclaration(signedDeclarationData, callback) {
    DataManager.__sendSimpleReq(signedDeclarationData, "/WebPms/Cosmos/users/UploadSignedStatement", callback);
  }

  static getRemoveCode(eik, sn, fdrid, callback) {
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    if (DataManager.___demoMode) {
      DataManager.data[DataManager.DataType.remove_code.dataid] = "TEST" + eik;
      setTimeout(() => {
        if (callback) callback(DataManager.last_error);
      }, 300);
    } else {
      HTTPSender.SendPOSTreq(JSON.stringify({ eik: eik, sn: sn, fdrid: fdrid }), DataManager.IIS_SERVER_URL, "/WebPms/Cosmos/Users/GetRemoveAccessCodeForClient")
        .done((resp) => {
          DataManager.__analyzeData(resp, this.DataType.remove_code, false, callback);
        })
        .fail((xhr, textStatus, errorThrown) => {
          DataManager.__analyzeFail(xhr, this.DataType.remove_code, callback, textStatus, errorThrown);
        });
    }
  }

  static getDeviceSubscriptionChange(deviceId, callback) {
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    if (DataManager.___demoMode) {
      //TODO
      setTimeout(() => {
        if (callback) callback(DataManager.last_error);
      }, 300);
    } else {
      HTTPSender.SendPOSTreq(JSON.stringify({ devId: deviceId }), DataManager.IIS_SERVER_URL, "/WebPms/cosmos/Devices/GetSubscriptionsLog")
        .done((resp) => {
          DataManager.__analyzeData(resp, null, false, callback);
        })
        .fail((xhr, textStatus, errorThrown) => {
          DataManager.__analyzeFail(xhr, null, callback, textStatus, errorThrown);
        });
    }
  }

  /**
   *
   * @param {*} invoiceData
   * @param {function(ErrorMessage)} callback
   */
  static updateUserInvoiceData(invoiceData, callback) {
    DataManager.__sendSimpleReq(invoiceData, "/WebPms/Cosmos/users/ChangeCUserInvData", callback);
  }

  static changeUserContactInfo(emailDeviceAction, callback) {
    DataManager.__sendSimpleReq(
      {
        emailDeviceAction: emailDeviceAction,
        receivesFuvasActionsMail: !!emailDeviceAction,
      },
      "/WebPms/Cosmos/Users/ChangeCuserContactInfo",
      callback,
    );
  }

  /**
   *
   * @param {*} userSettings
   * @param {function(ErrorMessage)} callback
   */
  static changeUserPassword(password, callback) {
    DataManager.__sendSimpleReq(password, "/WebPms/Cosmos/users/ChangePassword", callback);
  }

  static sendForgottenPasswordEmail(username, callback) {
    DataManager.__sendSimpleReq(username, "/WebPms/Cosmos/Users/GetPswResetCode", callback);
  }

  static changeUserPasswordWithResetCode(userObj, callback) {
    DataManager.__sendSimpleReq(userObj, "/WebPms/Cosmos/Users/UsePswResetCode", callback);
  }

  /**
   *
   * @param {*} userSettings
   * @param {function(ErrorMessage)} callback
   */
  static updateUserSettings(settings1, settings2, settings3, emailGlobal, emailDeviceActionGlobal, callback) {
    var userSettings = {};
    if (settings1) userSettings.settings1 = JSON.stringify(settings1);
    if (settings2) userSettings.settings2 = JSON.stringify(settings2);
    if (settings3) userSettings.settings3 = JSON.stringify(settings3);
    if (emailGlobal) {
      userSettings.email = emailGlobal;
    }
    if (emailDeviceActionGlobal) {
      userSettings.emailDevieAction = emailDeviceActionGlobal;
      userSettings.receiceDevAction = true;
    }
    if (TR.Locale == Translation.bg.Locale) {
      DataManager.__sendSimpleReq(userSettings, "/WebPms/Cosmos/users/ChangeCUserSettings", callback);
    } else {
      DataManager.__sendSimpleReq(userSettings, "/WebPms/GTA/changeUserSettings", callback);
    }
  }

  static markMessages(messages, callback) {
    DataManager.__sendSimpleReq(messages, "/WebPms/Cosmos/users/MarkMessage", callback);
  }

  static setBatch(arr, callback) {
    DataManager.__sendSimpleReq(arr, "/WebPms/Cosmos/devices/SetBatch", callback);
  }

  static createDistribPayRequest(distribEik, clientEik, amount, callback) {
    var o = {
      byDistribEik: distribEik,
      forCuserEik: clientEik,
      amount: amount,
    };
    DataManager.__sendSimpleReq(o, "/WebPms/Cosmos/Balance/CreateBalancePayRequest", callback);
  }

  static __sendSimpleReq(data, path, callback) {
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    if (DataManager.___demoMode) {
      if (callback) callback(DataManager.last_error);
    } else {
      HTTPSender.SendPOSTreq(JSON.stringify(data), TR.Locale == Translation.bg.Locale ? DataManager.IIS_SERVER_URL : DataManager.RO_IIS_SERVER_URL, path)
        .done((resp) => {
          //.done(async (resp) => { TODO async???
          DataManager.__analyzeData(resp, null, false, callback);
        })
        .fail((xhr, textStatus, errorThrown) => {
          DataManager.__analyzeFail(xhr, null, callback, textStatus, errorThrown);
        });
    }
  }

  static generatePaymentReason(qparams, callback) {
    DataManager.__sendSimpleGetReq(qparams, "/WebPms/Cosmos/Users/GenerateClientPReqCode", callback);
  }

  static __sendSimpleGetReq(qparams, path, callback) {
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    if (DataManager.___demoMode) {
      if (callback) {
        if (path == "/WebPms/Cosmos/Users/GenerateClientPReqCode") {
          callback(DataManager.last_error, { code: "TA-ДЕМО-123456" });
        } else {
          callback(DataManager.last_error);
        }
      }
    } else {
      HTTPSender.SendGETreq(DataManager.IIS_SERVER_URL, path, null, qparams)
        .done((resp) => {
          // TODO async???
          DataManager.__analyzeData(resp, null, false, callback);
        })
        .fail((xhr, textStatus, errorThrown) => {
          DataManager.__analyzeFail(xhr, null, callback, textStatus, errorThrown);
        });
    }
  }

  /**
   *
   * @param {any} user
   * @param {function(ErrorMessage)} callback
   */
  static register(user, callback) {
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    HTTPSender.SendPOSTreq(JSON.stringify(user), DataManager.IIS_SERVER_URL, "/WebPms/Cosmos/users/register")
      .done((resp) => {
        DataManager.__analyzeData(resp, null, false, callback);
      })
      .fail((xhr, textStatus, errorThrown) => {
        DataManager.__analyzeFail(xhr, null, callback, textStatus, errorThrown);
      });
  }

  /**
   *
   * @param {*} devs
   * @param {function(ErrorMessage)} callback
   */
  static updateDevProfile(devs, callback) {
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    if (DataManager.___demoMode) {
      DataManager.reloadDeviceData(callback);
    } else {
      var devsO = [];
      if (devs instanceof Array) {
        devs.forEach((d) => {
          if (d.duprofile) {
            devsO.push(DataManager.__cleanDevProfile(d, null));
          }
        });
      } else {
        if (devs.duprofile) {
          devsO.push(DataManager.__cleanDevProfile(devs, null));
        }
      }
      HTTPSender.SendPOSTreq(JSON.stringify([...devsO]), DataManager.IIS_SERVER_URL, "/WebPms/Cosmos/devices/ChangeProfile")
        .done(async (resp) => {
          if (await DataManager.__analyzeData(resp, null, false, null)) {
            DataManager.reloadDeviceData(callback).then(() => {
              bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.devices);
            });
          }
        })
        .fail((xhr, textStatus, errorThrown) => {
          DataManager.__analyzeFail(xhr, null, callback, textStatus, errorThrown);
        });
    }
  }

  static updateDevNameAndSettingsGlobal(devSn, devName, devSettings, callback) {
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    if (DataManager.___demoMode) {
      DataManager.reloadDeviceData(callback);
    } else {
      var devO = { sn: devSn };
      if (devSettings) {
        devO.settings1 = JSON.stringify(devSettings);
      }
      if (devName) {
        devO.devName = devName;
      }
      HTTPSender.SendPOSTreq(JSON.stringify(devO), DataManager.RO_IIS_SERVER_URL, "/WebPms/GTA/changeDevSettings")
        .done(async (resp) => {
          if (await DataManager.__analyzeData(resp, null, false, null)) {
            var dev = DataManager.data[DataManager.DataType.devices.dataid].find((d) => d.id == resp.payload.id);
            if (dev) {
              Object.assign(dev, JSON.parse(JSON.stringify(resp.payload), reviver));
              await DataManager.__fixData(DataManager.DataType.devices);
              bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.devices);
            }
          }
          if (callback) callback(DataManager.last_error);
        })
        .fail((xhr, textStatus, errorThrown) => {
          DataManager.__analyzeFail(xhr, null, callback, textStatus, errorThrown);
        });

      // DataManager.__sendSimpleReq(devO, "/WebPms/GTA/changeDevSettings", (resp) => {
      //   if (resp.success && resp.payload) {
      //     var dev = DataManager.data[DataManager.DataType.devices.dataid].find((d) => d.id == resp.payload.id);
      //     if (dev) {
      //       Object.assign(dev, resp.payload);
      //       DataManager.reloadDeviceData(callback).then(() => {
      //         bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.devices);
      //       });
      //     }
      //   }
      // });
    }
  }

  /**
   * @param {any[]} devs
   * @param {any} csubscriptionPlan
   * @param {function(ErrorMessage)} callback
   */
  static subscribe(devs, csubscriptionPlan, callback) {
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    var devsO = [];
    //console.log(csubscriptionPlan);
    devs.forEach((d) => {
      if (!d.duprofile) {
        d.duprofile = {};
      }
      var o = DataManager.__cleanDevProfile(d, csubscriptionPlan);
      devsO.push(o);
    });
    //console.log("subscribe\n" + JSON.stringify(devsO))
    if (DataManager.___demoMode) {
      DataManager.reloadDeviceData(callback);
    } else {
      HTTPSender.SendPOSTreq(JSON.stringify(devsO), DataManager.IIS_SERVER_URL, "/WebPms/Cosmos/devices/subscribe")
        .done(async (resp) => {
          if (await DataManager.__analyzeData(resp, null, false, callback)) {
            DataManager.reloadDeviceData(callback, true);
          }
        })
        .fail((xhr, textStatus, errorThrown) => {
          DataManager.__analyzeFail(xhr, null, callback, textStatus, errorThrown);
        });
    }
  }

  static async reloadDeviceData(callback, force_reload) {
    if (DataManager.___demoMode) {
      setTimeout(async () => {
        if (!DataManager.data[DataManager.DataType.devices.dataid] || DataManager.data[DataManager.DataType.devices.dataid].length == 0) {
          if (TR.Locale == Translation.bg.Locale) {
            DataManager.data[DataManager.DataType.devices.dataid] = JSON.parse(JSON.stringify(require("@/assets/demo/devices.json")), reviver);
          } else if (TR.Locale == Translation.ro.Locale || TR.Locale == Translation.md.Locale) {
            DataManager.data[DataManager.DataType.devices.dataid] = JSON.parse(JSON.stringify(require("@/assets/demoro/devices.json")), reviver);
          }
          await DataManager.__fixData(DataManager.DataType.devices);
          await DataManager.data[DataManager.DataType.devices.dataid].asyncForEach((dev) => {
            if (dev.duprofile && dev.duprofile.cosmosDevice) {
              dev.duprofile.isOnline = true; //FAKE
              dev.duprofile.lastOnline = new Date().addMinutes(-5); //FAKE
            }
          });
        } else {
          await DataManager.__fixData(DataManager.DataType.devices);
        }
        if (callback) callback(DataManager.last_error);
      }, 300);
    } else {
      if (!force_reload) {
        force_reload = false;
      }
      return DataManager.loadData(
        DataManager.DataType.devices,
        () => {
          //console.log(JSON.stringify(DataManager.data[DataManager.DataType.devices.id]));
          DataManager.__fixData(DataManager.DataType.devices);
          if (callback) callback(DataManager.last_error);
        },
        force_reload,
      );
    }
  }

  static __startMonitor() {
    if (!DataManager.monitorFunction && (DataManager.userType & DataManager.UserTypes.Owner) > 0) {
      DataManager.monitorFunction = setInterval(() => {
        if (SHOW_DEBUG_MESSAGES) console.log("НАФТОВА ПОМПА 1.9 TDI");
        if (!DataManager.sales_loaded) {
          return;
        }
        if (DataManager.___demoMode) {
          if (DataManager.data[DataManager.DataType.sales.dataid] == null) return;
          var devIdx = Math.randomFromInterval(0, DataManager.data[DataManager.DataType.devices.dataid].length - 1);
          var dev = DataManager.data[DataManager.DataType.devices.id][devIdx];
          if (!dev.duprofile.cosmosDevice || !DataManager.data[DataManager.DataType.daily.dataid]) return;
          var repNum = Math.max(...DataManager.data[DataManager.DataType.daily.dataid].filter((r) => r.sn == dev.sn).map((r) => r.num)) + 1;
          var recNum = Math.max(...DataManager.data[DataManager.DataType.sales.dataid].filter((r) => r.sn == dev.sn).map((r) => r.rcp.rcpNum)) + 1;
          new Promise((resolve) => {
            resolve(DataManager.__generateReceipt(dev, repNum, recNum, new Date(), 5));
          }).then((rec) => {
            if (rec != null) {
              DataManager.data[DataManager.DataType.sales.dataid].push(rec);
            }
            DataManager.__fixData(DataManager.DataType.sales);
          });
        } else {
          HTTPSender.SendGETreq(DataManager.DataType.monitor.url, DataManager.DataType.monitor.path)
            .done(async (response) => {
              if (!(await DataManager.__analyzeData(response, DataManager.DataType.monitor, false, null))) {
                return;
              }
              //console.log(response);
              //console.log(JSON.stringify(response));
              //console.log(DataManager.data[DataManager.DataType.monitor.id]);
              var dateM = null;
              var dateZ = null;
              var dateS = null;
              var devsM = [];
              var devsS = [];
              var devsZ = [];
              DataManager.data[DataManager.DataType.monitor.dataid].devActions.forEach((e) => {
                e.actions.forEach((a) => {
                  switch (a.type) {
                    case "M":
                      dateM = a.dateRcvd;
                      if (devsM.indexOf(e.sn) == -1) devsM.push(e.sn);
                      break;
                    case "Z":
                      dateZ = a.dateRcvd;
                      if (devsZ.indexOf(e.sn) == -1) devsZ.push(e.sn);
                      break;
                    case "S":
                    case "B":
                    case "P":
                      if (!dateS || dateS < a.dateRcvd) {
                        dateS = a.dateRcvd;
                      }
                      if (devsS.indexOf(e.sn) == -1) devsS.push(e.sn);
                      break;
                    default:
                      break;
                  }
                });
              });

              if (dateM && DataManager.data[DataManager.DataType.monthly.dataid] && DataManager.data[DataManager.DataType.monthly.dataid].length > 0) {
                DataManager.loadData(
                  DataManager.DataType.monthly,
                  null,
                  true,
                  DataManager.date_downloaded_to[DataManager.DataType.monthly.dataid],
                  null,
                  DataManager.getData(DataManager.DataType.devices, true).filter((d) => devsM.indexOf(d.sn) != -1),
                );
              }
              if (dateZ && DataManager.data[DataManager.DataType.daily.dataid] && DataManager.data[DataManager.DataType.daily.dataid].length > 0) {
                DataManager.loadData(
                  DataManager.DataType.daily,
                  null,
                  true,
                  DataManager.date_downloaded_to[DataManager.DataType.daily.dataid],
                  null,
                  DataManager.getData(DataManager.DataType.devices, true).filter((d) => devsZ.indexOf(d.sn) != -1),
                );
              }
              if (dateS && DataManager.data[DataManager.DataType.sales.dataid] && DataManager.data[DataManager.DataType.sales.dataid].length > 0) {
                DataManager.loadData(
                  DataManager.DataType.sales,
                  null,
                  true,
                  DataManager.date_downloaded_to[DataManager.DataType.sales.dataid],
                  null,
                  DataManager.getData(DataManager.DataType.devices, true).filter((d) => devsS.indexOf(d.sn) != -1),
                );
              }
              if (DataManager.data[DataManager.DataType.monitor.dataid].newMessages != DataManager.data[DataManager.DataType.messages.dataid].filter((f) => !f.seen).length) {
                DataManager.loadData(
                  DataManager.DataType.messages,
                  () => {
                    DataManager.loadData(DataManager.DataType.user, null, true);
                  },
                  true,
                );
              }
            })
            .fail((xhr, textStatus, errorThrown) => {
              DataManager.__analyzeFail(xhr, DataManager.DataType.monitor, null, textStatus, errorThrown);
            });
        }
      }, DataManager.monitorInterval);
    }
  }

  static Wait4DemoDataGenerating(callback) {
    setTimeout(() => {
      if (DataManager.___isDemoDataGenerated) {
        if (callback) callback(DataManager.last_error);
      } else {
        DataManager.Wait4DemoDataGenerating(callback);
      }
    }, 100);
  }

  static async __generateDemoData(datatype, callback, dateFrom, dateTo) {
    if (DataManager.___isDemoDataGenerated) {
      switch (datatype) {
        case DataManager.DataType.invoices_reports:
        case DataManager.DataType.sales_reports:
        case DataManager.DataType.sales_by_article_price:
        case DataManager.DataType.sales_by_articles:
        case DataManager.DataType.sales_by_hours_qty:
        case DataManager.DataType.sales_by_hours_price:
        case DataManager.DataType.sales_by_payments:
          if (dateTo) {
            var df = dateFrom.getTime();
            var dt = dateTo.getTime();
            DataManager.data[datatype.dataid] = DataManager.data[DataManager.DataType.sales.dataid].filter(
              (d) => d.date.getTime() >= df && d.date.getTime() <= dt && (d.ReceiptType == ReceiptType.fiscalReceipt || d.ReceiptType == ReceiptType.invoice || d.ReceiptType == ReceiptType.storno || d.ReceiptType == ReceiptType.creditNote),
            );
            DataManager.data[datatype.dataid].forEach((d) => (d.IsProcessed = false));
            await DataManager.__fixData(datatype);
          }
          break;
        case DataManager.DataType.daily_reports:
        case DataManager.DataType.daily_reports_grouped:
          if (dateTo) {
            var df2 = dateFrom.getTime();
            var dt2 = dateTo.getTime();
            DataManager.data[datatype.dataid] = DataManager.data[DataManager.DataType.daily.dataid].filter((d) => d.date.getTime() >= df2 && d.date.getTime() <= dt2);
          }
          break;
      }
      if (callback) callback(DataManager.last_error);
    } else {
      if (DataManager.___isDemoDataGenerating) {
        DataManager.Wait4DemoDataGenerating(callback);
      } else {
        DataManager.___isDemoDataGenerating = true;
        var days = navigator.sayswho.toLowerCase().indexOf("android") > -1 ? 30 : 60; //182;
        var maxRecs = 100;
        var maxItems = 5;
        var tempRec = [];
        var tempZ = [];
        var tempM = [];
        await DataManager.data[DataManager.DataType.devices.dataid]
          .asyncForEach(async (dev) => {
            if (dev.duprofile.cosmosDevice == false) return null;
            dev.fm = dev.sn.replace("ZK", "50");
            dev.ej = Math.randomFromInterval(1, 4);
            var now = new Date();
            var workingHours = Math.randomFromInterval(9, 13);
            var recInterval = (workingHours * 60) / maxRecs;
            var recNum = Math.randomFromInterval(1, 10000);
            var repNum = Math.randomFromInterval(1, 1000);
            var startDate = new Date().addDays(-days - 1);

            for (var d = 0; d <= days; d++) {
              var recsCount = Math.randomFromInterval(maxRecs / 2, maxRecs);
              var dt = new Date(startDate.addDays(d + 1).valueOf());
              dt.setHours(9);
              var zDT = dt.addHours(workingHours + 1).addMinutes(Math.randomFromInterval(1, 60));
              var sn = dev.sn;
              var rep = {
                sn: sn,
                fm: dev.fm,
                ej: dev.ej,
                num: repNum++,
                date: zDT,
                rcpsCount: 0,
                taxGrTurnovers: [{ tg: VAT_GROUPS[1], turnover: 0 }],
                taxGrTurnoversStorno: [],
                error: false,
              };
              var promises = [];
              for (var r = 0; r < recsCount; r++) {
                const prom = new Promise((resolve) => {
                  var recOffset = r * recInterval + Math.randomFromInterval(0, recInterval);
                  var recDt = dt.addMinutes(recOffset);
                  if (recDt <= now) {
                    resolve(DataManager.__generateReceipt(dev, rep.num, recNum++, recDt, maxItems));
                  } else {
                    resolve(null);
                  }
                }).then((rec) => {
                  if (rec == null) return;
                  tempRec.push(rec);
                  rep.rcpsCount++;
                  rep.taxGrTurnovers[0].turnover += rec.ttlSum;
                });
                promises.push(prom);
              }
              await Promise.all(promises).then(() => {
                Object.freeze(rep);
                if (zDT < now) {
                  tempZ.push(Object.assign({}, rep));
                  var fndM = tempM.find((m) => {
                    return m.date.getTime() === new Date(rep.date.getFullYear(), rep.date.getMonth(), 1).getTime() && m.sn == rep.sn && m.fm == rep.fm && m.ej == rep.ej;
                  });
                  if (!fndM) {
                    fndM = Object.assign(
                      {},
                      {
                        sn: rep.sn,
                        fm: rep.fm,
                        ej: rep.ej,
                        date: new Date(rep.date.getFullYear(), rep.date.getMonth(), 1),
                        rcpsCount: 0,
                        Sum: 0,
                        firstZRepNum: 9999,
                        lastZRepNum: 0,
                        taxGrTurnovers: [{ tg: VAT_GROUPS[1], turnover: 0 }],
                        taxGrTurnoversStorno: [],
                      },
                    );
                    tempM.push(fndM);
                  }
                  fndM.rcpsCount += rep.rcpsCount;
                  fndM.taxGrTurnovers[0].turnover += rep.taxGrTurnovers[0].turnover;
                  if (fndM.firstZRepNum > rep.num) {
                    fndM.firstZRepNum = rep.num;
                  }
                  if (fndM.lastZRepNum < rep.num) {
                    fndM.lastZRepNum = rep.num;
                  }
                }
              });
            }
            return dev;
          })
          .then((dev) => {
            if (dev != null) {
              dev.duprofile.isOnline = true;
              dev.duprofile.lastOnline = tempZ
                .slice()
                .reverse()
                .find((dd) => dd.sn === dev.sn).date;
            }
          })
          .then(async () => {
            var block_event = Object.assign({}, vmc_event);
            var dtt = new Date();
            block_event.rcp.date = dtt;
            block_event.dateReceived = dtt;
            tempRec.push(block_event);
            DataManager.data[DataManager.DataType.sales.dataid] = tempRec;
            DataManager.data[DataManager.DataType.daily.dataid] = tempZ;
            DataManager.data[DataManager.DataType.monthly.dataid] = tempM;
            DataManager.data[DataManager.DataType.sales_reports.dataid] = [];
            DataManager.data[DataManager.DataType.sales_by_articles.dataid] = [];
            DataManager.data[DataManager.DataType.sales_by_article_price.dataid] = [];
            DataManager.data[DataManager.DataType.sales_by_hours_qty.dataid] = [];
            DataManager.data[DataManager.DataType.sales_by_hours_price.dataid] = [];
            DataManager.data[DataManager.DataType.sales_by_payments.dataid] = [];
            DataManager.data[DataManager.DataType.daily_reports.dataid] = [];
            DataManager.data[DataManager.DataType.daily_reports_grouped.dataid] = [];

            await Promise.all([
              DataManager.__fixData(DataManager.DataType.devices),
              DataManager.__fixData(DataManager.DataType.monthly),
              DataManager.__fixData(DataManager.DataType.daily),
              DataManager.__fixData(DataManager.DataType.sales),
              DataManager.__fixData(DataManager.DataType.sales_reports),
            ]).then(async () => {
              var now = new Date();
              DataManager.___isDemoDataGenerating = false;
              DataManager.___isDemoDataGenerated = true;
              DataManager.data[DataManager.DataType.monthly.dataid] = DataManager.data[DataManager.DataType.monthly.dataid].filter((m) => !(m.MM == now.getMonth() && m.YY == now.getFullYear()));
              DataManager.__startMonitor();
              if (callback) callback(DataManager.last_error);
            });
          });
      }
    }
  }

  static async __generateReceipt(dev, repNum, recNum, dt, maxItems) {
    var resp = null;
    await new Promise(function (resolve) {
      setTimeout(() => {
        if (dev.IsFuvas && dev.IsBlocked == true) {
          var vmc_start = JSON.parse(JSON.stringify(vmc_event));
          vmc_start.id = dt.toStringWithFormat("yyMMddHHmmssnnn") + "VMC Start";
          vmc_start.freeTexts[0] = "VMC Start";
          vmc_start.rcp.date = dt;
          vmc_start.dateReceived = dt;
          vmc_start.sn = dev.sn;
          dev.IsBlocked = false;
          resolve(vmc_start);
        } else if (dev.IsFuvas && Math.randomFromInterval(1, 100) === 1) {
          var vmc_serviz = JSON.parse(JSON.stringify(vmc_event));
          vmc_serviz.id = dt.toStringWithFormat("yyMMddHHmmssnnn") + "VMC Serviz";
          vmc_serviz.freeTexts[0] = "VMC Serviz";
          vmc_serviz.rcp.date = dt;
          vmc_serviz.dateReceived = dt;
          vmc_serviz.sn = dev.sn;
          dev.IsBlocked = true;
          resolve(vmc_serviz);
        } else {
          var opNum = Math.randomFromInterval(1, 4);
          var isInvoice = !dev.IsFuvas && Math.randomFromInterval(1, 50) === 1;
          var rec = {
            sn: dev.sn,
            fm: dev.fm,
            klen: dev.ej,
            ttlSum: 0,
            eik: dev.eik,
            rcp: {
              rcpType: "FiscRcp",
              rcpTypeCode: isInvoice ? 50 : 49,
              rcpNum: recNum,
              date: dt,
              zrepNum: repNum,
              void: false,
            },
            dateReceived: dt,
            operator: { name: TR.Operator + " " + opNum, num: opNum },
            sales: [],
            taxGrSums: [],
            payments: [],
          };
          if (isInvoice) {
            var clNum = Math.randomFromInterval(1, 8);
            rec.invoiceData = {
              invNum: dev.id + recNum.toString().padStart(9, "0"),
              clientCompanyName: TR.Customer + " 90909090" + clNum,
              clientMOL: TR.CustomerMolName,
              clientCompanyAddress: dev.Address.padEnd(30, " ").substring(0, 30),
              clientEik: "90909090" + clNum,
              zddsNum: TR.Locale.toUpperCase() + "90909090" + clNum,
            };
          }
          var itemsCount = Math.randomFromInterval(1, dev.IsFuvas ? 1 : maxItems);
          var sum = 0;
          for (var i = 0; i < itemsCount; i++) {
            var itemNameIdx = Math.randomFromInterval(1, dev.IsFuvas ? 4 : 7);
            var itemName = "";
            var itemPrice = 0;
            switch (itemNameIdx) {
              case 1:
                itemName = TR.DefaultItem1;
                itemPrice = 0.4;
                break;
              case 2:
                itemName = TR.DefaultItem2;
                itemPrice = 0.3;
                break;
              case 3:
                itemName = TR.DefaultItem3;
                itemPrice = 0.8;
                break;
              case 4:
                itemName = TR.DefaultItem4;
                itemPrice = 0.55;
                break;
              case 5:
                itemName = TR.DefaultItem5;
                itemPrice = 0.99;
                break;
              case 6:
                itemName = TR.DefaultItem6;
                itemPrice = 0.35;
                break;
              case 7:
                itemName = TR.DefaultItem7;
                itemPrice = 0.3;
                break;
              default:
                itemName = TR.DefaultItem;
                itemPrice = 1.0;
                break;
            }
            var itemQuantity = Math.randomFromInterval(1, 5);
            if (dev.IsFuvas) {
              itemName = "Vending";
              itemQuantity = 1;
            }
            var itemSum = Number(itemQuantity * itemPrice).roundTo(2);
            var item = Object.freeze({
              num: i + 1,
              name: itemName,
              type: "Art",
              typeCode: 49,
              void: false,
              taxGr: VAT_GROUPS[1],
              qty: itemQuantity,
              price: itemPrice,
              sum: itemSum,
              finalPrice: itemSum,
            });
            rec.sales.push(item);
            sum = sum + itemSum;
          }
          rec.ttlSum = sum;
          rec.taxGrSums.push(
            Object.freeze({
              taxGr: VAT_GROUPS[1],
              vatPrc: 20,
              vat: ((rec.ttlSum * 20) / 100).roundTo(2),
              sum: sum,
            }),
          );
          rec.payments.push(
            Object.freeze({
              sum: sum,
              payType: Math.randomFromInterval(1, 50) == 1 && !dev.IsFuvas ? TR.Card : TR.InCash,
            }),
          );
          resolve(rec);
        }
      }, 0);
    }).then(function fnOk(respOK) {
      resp = respOK;
    });
    return resp;
  }

  static __cleanDevProfile(dev, subPlan) {
    var o = {
      devId: dev.id,
      // id: dev.id,
      // sn: dev.sn,

      // duprofile: {
      //   cosmosDevice: dev.duprofile.cosmosDevice,
      // },
    };
    if (subPlan) {
      o.csubscriptionPlanId = subPlan.id;
    } else {
      o.duprofile = {
        cuComment: dev.duprofile.cuComment,
        settings1: JSON.stringify(dev.duprofile.settings1),
        settings2: JSON.stringify(dev.duprofile.settings2),
        settings3: JSON.stringify(dev.duprofile.settings3),
      };
    }
    return o;
  }

  /**
   *
   * @param {DataManager.DataType} datatype
   * @param {function(ErrorMessage)} callback
   */
  static async loadData(datatype, callback, forceLoad, dateFrom, dateTo, devices) {
    if (SHOW_DEBUG_MESSAGES) {
      console.log("loadData");
      console.log(datatype.name);
      console.log(forceLoad);
      console.log(dateFrom);
      console.log(dateTo);
      console.log(devices);
      console.log("len: " + DataManager.data[datatype.dataid].length);
    }
    DataManager.data_is_loading[datatype.id] = true;
    DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_OK, 200, null, []);
    if (!forceLoad && DataManager.data[datatype.dataid] != null && (!(DataManager.data[datatype.dataid] instanceof Array) || DataManager.data[datatype.dataid].length > 0)) {
      setTimeout(() => {
        if (callback) callback(DataManager.last_error);
      }, 20); //some fuckin redraw shits
    } else {
      if (datatype.access_type) {
        if (DataManager.___demoMode) {
          await DataManager.__generateDemoData(datatype, callback, dateFrom, dateTo);
          return this;
        } else {
          var chunkSize = DataManager.chunkSizeDefault;
          if (datatype.chunk_size) {
            chunkSize = datatype.chunk_size;
          }

          // console.log("load days " + datatype.load_days)
          var df = dateFrom ?? new Date().getDateWithoutTime().addDays(1 - datatype.load_days);
          var dt = dateTo ?? new Date();

          //var devsData = DataManager.getData(DataManager.DataType.devices, true);
          var devs = devices;
          if (!devs) {
            devs = DataManager.data[DataManager.DataType.devices.dataid].filter((d) => d.IsForMe);
          }
          if (!devs) {
            if (callback) {
              DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_FAIL, 401, TR.PleaseLogin, []);
              callback(DataManager.last_error);
            }
            return this;
          }
          var devsWithPlan = devs.filter(
            (d) =>
              (d.featureAccess && d.featureAccess.indexOf(datatype.access_type) != -1) || //RO devs
              (d.duprofile && d.duprofile.cosmosDevice && d.duprofile.csubscriptionPlan && d.duprofile.csubscriptionPlan.featureAccess && d.duprofile.csubscriptionPlan.featureAccess.indexOf(datatype.access_type) != -1),
          );

          if (!devsWithPlan || devsWithPlan.length == 0) {
            if (callback) {
              DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_FAIL, 200, TR.NoDevsSubscribedForThisData, []);
              callback(DataManager.last_error);
            }
            return this;
          }

          var devsBrief = devsWithPlan.filter((d) => datatype.access_type == "S" && d.IsFuvas && !d.HasCardPayment);
          var devsDetailed = devsWithPlan.filter((d) => datatype.access_type != "S" || !d.IsFuvas || d.HasCardPayment);
          var devsOMulti = [];
          if (datatype.LastOnly) {
            devsBrief.splitToChunks(chunkSize).forEach((devs) => {
              devsOMulti.push({
                Type: datatype.access_type,
                BriefFormat: false, // BriefFormat: true,
                LastOnly: true,
                devices: devs.map(function (d) {
                  return { devId: d.id, sn: d.sn };
                }),
              });
            });
            devsDetailed.splitToChunks(chunkSize).forEach((devs) => {
              devsOMulti.push({
                Type: datatype.access_type,
                BriefFormat: false,
                LastOnly: true,
                devices: devs.map(function (d) {
                  return { devId: d.id, sn: d.sn };
                }),
              });
            });
          } else if (datatype.num_from) {
            devsBrief.splitToChunks(chunkSize).forEach((devs) => {
              devsOMulti.push({
                Type: datatype.access_type,
                NumFrom: datatype.num_from,
                devices: devs.map(function (d) {
                  return { devId: d.id, sn: d.sn };
                }),
              });
            });
            devsDetailed.splitToChunks(chunkSize).forEach((devs) => {
              devsOMulti.push({
                Type: datatype.access_type,
                NumFrom: datatype.num_from,
                devices: devs.map(function (d) {
                  return { devId: d.id, sn: d.sn };
                }),
              });
            });
          } else if (dateTo) {
            devsBrief.splitToChunks(chunkSize).forEach((devs) => {
              devsOMulti.push({
                Type: datatype.access_type,
                DateFrom: dateFrom.toStringWithFormat("yyyy-MM-ddTHH:mm:ss.nnn"),
                DateTo: dateTo.toStringWithFormat("yyyy-MM-ddTHH:mm:ss.nnn"),
                BriefFormat: TR.Locale == Translation.bg.Locale,
                UseRcpDate: true,
                LastOnly: false,
                devices: devs.map(function (d) {
                  return { devId: d.id, sn: d.sn };
                }),
              });
            });
            devsDetailed.splitToChunks(chunkSize).forEach((devs) => {
              devsOMulti.push({
                Type: datatype.access_type,
                DateFrom: dateFrom.toStringWithFormat("yyyy-MM-ddTHH:mm:ss.nnn"),
                DateTo: dateTo.toStringWithFormat("yyyy-MM-ddTHH:mm:ss.nnn"),
                BriefFormat: false,
                UseRcpDate: true,
                LastOnly: false,
                devices: devs.map(function (d) {
                  return { devId: d.id, sn: d.sn };
                }),
              });
            });
          } else {
            devsBrief.splitToChunks(chunkSize).forEach((devs) => {
              devsOMulti.push({
                Type: datatype.access_type,
                DateFrom: df.toUTCString(),
                BriefFormat: TR.Locale == Translation.bg.Locale,
                LastOnly: false,
                // UseRcpDate: true,
                devices: devs.map(function (d) {
                  return { devId: d.id, sn: d.sn };
                }),
              });
            });
            devsDetailed.splitToChunks(chunkSize).forEach((devs) => {
              devsOMulti.push({
                Type: datatype.access_type,
                DateFrom: df.toUTCString(),
                BriefFormat: false,
                LastOnly: false,
                // UseRcpDate: true,
                devices: devs.map(function (d) {
                  return { devId: d.id, sn: d.sn };
                }),
              });
            });
          }
          // if(datatype.access_type == "S") {
          //   devsOMulti.forEach(om =>  {
          //     delete om.DateFrom;
          //     om.LastOnly = true;
          //   })
          // }

          let fail = false;
          var proms = [];
          var respArr = [];
          if (SHOW_DEBUG_MESSAGES) {
            var cnt = 0;
          }
          for (var i = 0; i < devsOMulti.length; i++) {
            proms.push(
              new Promise((resolve) => {
                HTTPSender.SendPOSTreq(JSON.stringify(devsOMulti[i]), datatype.url, datatype.path)
                  .done(async (response) => {
                    if (!fail) {
                      if (response instanceof Array) {
                        respArr.push(...response);
                      } else {
                        respArr = response;
                        fail = true;
                      }
                      if (SHOW_DEBUG_MESSAGES) {
                        console.log(datatype.name + " package " + cnt++);
                      }
                    }
                    resolve();
                  })
                  .fail(async (xhr, textStatus, errorThrown) => {
                    await DataManager.__analyzeFail(xhr, datatype, callback, textStatus, errorThrown);
                    fail = true;
                    if (SHOW_DEBUG_MESSAGES) {
                      console.log(datatype.name + " package FAIL" + cnt++);
                    }
                    resolve();
                  });
              }),
            );
          }
          if (!fail) {
            await Promise.all(proms);
            await DataManager.__analyzeData(respArr, datatype, !!datatype.append_data, null);
            if (!DataManager.sales_loaded && datatype.initial && datatype.access_type == "S") {
              DataManager.sales_loaded = true;
            }
            DataManager.date_downloaded_to[datatype.id] = dt.addMilliseconds(1);
            if (callback) callback(DataManager.last_error);
          } else {
            //TODO FAIL?
          }
        }
      } else {
        if (DataManager.___demoMode) {
          if (callback) {
            callback(DataManager.last_error);
          }
        } else {
          if (datatype.url) {
            HTTPSender.SendGETreq(datatype.url, datatype.path)
              .done((response) => {
                DataManager.__analyzeData(response, datatype, false, callback);
              })
              .fail((xhr) => {
                //, textStatus, errorThrown) {
                DataManager.__analyzeFail(xhr, datatype, callback);
              });
          } else {
            // Няма url, значи жулим фалшиви данни
            DataManager.__fixData(datatype).then(() => {
              if (callback) callback(DataManager.last_error);
            });
          }
        }
      }
    }
    return this;
    // }
  }

  static async __analyzeData(resp, type, append, callback) {
    if (type) DataManager.data_is_loading[type.id] = false;
    //console.log("rid: " + resp.rid);
    var response = resp.payload || resp.Payload;
    if (!response) response = resp;
    if (resp.success == false || resp.Success == false) {
      var err = resp.err || resp.Err;
      DataManager.last_error = new ErrorMessage(err.code || err.Code, 200, err.message || err.Message, err.errDetails || err.ErrDetails);
      if (callback) {
        if (SHOW_DEBUG_MESSAGES) {
          console.log("__analyzeData error in response, (type " + type + "):");
          // console.log(JSON.stringify(response));
          console.log(DataManager.last_error);
        }
        callback(DataManager.last_error);
      }
      return false;
    }
    if (type == null) {
      if (callback) callback(DataManager.last_error, response);
      return true;
    }

    if (SHOW_DEBUG_MESSAGES) console.log("__analyzeData " + type.name + " (" + typeof response + ") " + (response.length ?? 1) + " нови записа");

    //console.log(JSON.stringify(response));
    if (typeof response == "string") {
      response = JSON.parse(response, reviver);
    }
    if (response instanceof Array) {
      if (DataManager.data[DataManager.DataType.user.dataid] == null || DataManager.data[DataManager.DataType.user.dataid].length == 0) {
        throw new Error(TR.PleaseLogin);
      }
      response = JSON.parse(JSON.stringify(response), reviver);
      if (!append) {
        DataManager.data[type.dataid].splice(0);
      }

      if (DataManager.data[type.dataid].length == 0) {
        DataManager.data[type.dataid].push(...response);
      } else {
        //идват от помпата, проверяваме за дублиране
        if (DataManager.data[type.dataid][0].id) {
          var uqIds = DataManager.data[type.dataid].map((i) => i.id); //гледаме дали имат id
          DataManager.data[type.dataid].push(...response.filter((r) => uqIds.indexOf(r.id) == -1));
        } else {
          DataManager.data[type.dataid].push(...response);
        }
      }
      // DataManager.data[type.dataid] = DataManager.data[type.dataid].map((item, index) => ({
      //   my_custom_id: index,
      //   ...item,
      // }));
    } else if (response instanceof Object) {
      response = JSON.parse(JSON.stringify(response), reviver);
      DataManager.data[type.dataid] = response;
    } else {
      DataManager.data[type.dataid] = response;
      // DataManager.data[type.id] = [];
      // DataManager.last_error = new ErrorMessage(ErrorMessage.ERROR_CODE_FAIL, 200, JSON.stringify(response), []);
    }
    if (type == DataManager.DataType.user) {
      var user = DataManager.data[type.dataid];
      HTTPSender.SetBearer(user.token);

      if (DataManager.data[DataManager.DataType.user.dataid].observerCuser) {
        DataManager.userType = DataManager.UserTypes.Observer;
      } else if (DataManager.data[DataManager.DataType.user.dataid].isDistributor) {
        DataManager.userType = DataManager.UserTypes.Distributor;
      } else {
        DataManager.userType = DataManager.UserTypes.Owner;
        if (DataManager.userHasTelemetry) {
          DataManager.userType |= DataManager.UserTypes.OwnerWithTelemetry;
        }
        if (TR.Locale == Translation.ro.Locale) {
          // if (user.id == 712 || user.id == 713) { //TODO за повече пари ?!
          DataManager.userType |= DataManager.UserTypes.OwnerWithXML;
        }
        // }
      }

      if (!user.settings1) user.settings1 = {};
      if (!user.settings2) user.settings2 = {};
      if (!user.settings3) user.settings3 = {};
      try {
        if (!(user.settings1 instanceof Object)) user.settings1 = JSON.parse(user.settings1, reviver);
      } catch {
        user.settings1 = {};
      }
      try {
        if (!(user.settings2 instanceof Object)) {
          user.settings2 = JSON.parse(user.settings2, reviver);
        }
      } catch {
        user.settings2 = {};
      }
      try {
        if (!(user.settings3 instanceof Object)) user.settings3 = JSON.parse(user.settings3, reviver);
      } catch {
        /** ignored */
        //user.settings3 = {};
      }
      if (user.settings2 instanceof Array) {
        var clientz = user.settings2;
        user.settings2 = { clients: clientz };
      }
      if (user.settings2.technicians) {
        user.settings2.technicians.forEach((t) => {
          if (t.n === undefined) {
            t.n = t.name;
            delete t.name;
          }
          if (t.c === undefined) {
            t.c = t.comment;
            delete t.comment;
          }
          if (t.n === undefined) {
            t.p = t.phone;
            delete t.phone;
          }
          t.toString = function () {
            return this.n ?? this.name;
          };
        });
      } else {
        user.settings2.technicians = [];
      }
      if (TR.Locale == Translation.bg.Locale) {
        if (!user.settings2.clients) user.settings2.clients = [];
        if (!user.settings2.maintenanceschedules) user.settings2.maintenanceschedules = [];
        if (!user.settings2.telemetryschedules) user.settings2.telemetryschedules = [];
        else
          user.settings2.telemetryschedules.forEach((s, idx) => {
            user.settings2.telemetryschedules[idx] = new TelemetrySchedule(s.Values);
          });
      }
    }
    await DataManager.__fixData(type);
    if (callback) callback(DataManager.last_error);
    return true;
  }

  static async __analyzeFail(xhr, datatype, callback, textStatus, errorThrown) {
    if (SHOW_DEBUG_MESSAGES) {
      console.log("__analyzeFail");
      console.log(xhr.status);
      console.log(xhr.response);
      console.log(xhr.responseJSON);
      console.log(textStatus);
      console.log(errorThrown);
    }
    if (datatype) DataManager.data_is_loading[datatype.id] = false;
    var errCode = ErrorMessage.ERROR_CODE_FAIL;
    var msg = "";
    var errDetails = null;
    var json = xhr.responseJSON;
    if (!json && xhr.response) json = JSON.parse(xhr.response);
    if (json) {
      msg = TR.ServerError + ": " + (json.Message || json.message);
      errCode = json.ErrorCode;
      errDetails = json.ErrorDetails || json.errorDetails;
    } else {
      if (xhr.readyState == 4) {
        msg = xhr.status + ": " + xhr.statusText;
      } else if (xhr.readyState == 0) {
        msg = TR.ServerNoConnection;
      } else {
        msg = TR.ErrorUnknown;
      }
    }
    DataManager.last_error = new ErrorMessage(errCode, xhr.statusCode, msg, errDetails);
    if (callback) {
      callback(DataManager.last_error);
    }
    // TODO check?
    if (xhr.status == 401) {
      DataManager.__clean();
      window.location.href = "https://a.tremol.bg/login";
    }
  }

  static async __fixData(datatype) {
    var today = new Date().getDateWithoutTime();
    var monday = new Date().getMonday().getDateWithoutTime();
    if (SHOW_DEBUG_MESSAGES) {
      console.log("__fixData start " + datatype.name);
    }
    var proms = [];
    // TODO редовете в които error: true ?!?
    switch (datatype) {
      case DataManager.DataType.devices:
        DataManager.data[DataManager.DataType.devices.dataid].forEach((d) => {
          proms.push(
            new Promise((resolve) => {
              if (SHOW_DEBUG_MESSAGES) {
                console.log("__fixData dev process");
              }
              if (!d.model) {
                if (d.modelId) {
                  switch (d.modelId) {
                    case 1:
                    case 20:
                    case 21:
                    case 28:
                    case 83:
                      d.model = { name: "Tremol M20" };
                      break;
                    case 2:
                    case 30:
                    case 40:
                      d.model = { name: "Tremol M23" };
                      break;
                    case 3:
                    case 22:
                    case 78:
                      d.model = { name: "Tremol S21" };
                      break;
                    case 4:
                    case 23:
                    case 31:
                      d.model = { name: "Tremol S25" };
                      break;
                    case 5:
                    case 27:
                    case 33:
                      d.model = { name: "Tremol A19 Plus" };
                      break;
                    case 12:
                    case 24:
                    case 79:
                    case 80:
                      d.model = { name: "Tremol FP15" };
                      break;
                    case 13:
                      d.model = { name: "Tremol FP21" };
                      break;
                    case 15:
                      d.model = { name: "Tremol FP17" };
                      break;

                    case 11:
                    case 84:
                    default:
                      d.model = { name: "Tremol V" };
                      break;
                  }
                } else {
                  d.model = { name: "Tremol V" };
                }
              }
              if (d.Image === undefined) {
                d.IsFuvas = d.model.name.startsWith("Tremol V");
                d.IsOldFuvas = d.model.name.startsWith("Tremol V-KL");
                var filename = (d.model.name.endsWith("V2") ? d.model.name.substring(0, d.model.name.length - 3) : d.model.name) + ".png";
                if (!bus.models[filename]) {
                  var img = null;
                  try {
                    img = require(`@/assets/img/` + filename);
                  } catch {
                    img = require(`@/assets/img/Tremol ZM-KL.png`);
                  }
                  bus.models[filename] = { Name: d.model.name, Image: img };
                }
                d.Image = bus.models[filename].Image;
              }
              if (!d.Address) {
                if (d.currentAddr) {
                  d.Address =
                    "България, " +
                    (d.currentAddr.nmKind ? d.currentAddr.nmKind + " " : "") +
                    d.currentAddr.naselenoMiasto +
                    ", " +
                    (d.currentAddr.ulica ? d.currentAddr.ulica.replace("БУЛ.", "бул. ").replace("Бул.", "бул. ").replace("бул.", "бул. ").replace("ул.", "ул. ").replace("УЛ.", "ул. ") + (d.currentAddr.ulicaNum ? " " + d.currentAddr.ulicaNum : "") : "");
                } else {
                  Object.defineProperty(d, "Address", {
                    get() {
                      return d.settings1.Address ?? "";
                    },
                    set(val) {
                      d.settings1.Address = val;
                    },
                    configurable: true,
                    enumerable: true,
                  });
                }
              }
              if (d.duprofile) {
                if (d.duprofile.settings1 && (typeof d.duprofile.settings1 === "string" || d.duprofile.settings1 instanceof String))
                  try {
                    d.duprofile.settings1 = JSON.parse(d.duprofile.settings1);
                  } catch {
                    d.duprofile.settings1 = {};
                  }

                if (d.duprofile.settings2 && (typeof d.duprofile.settings2 === "string" || d.duprofile.settings2 instanceof String))
                  try {
                    d.duprofile.settings2 = JSON.parse(d.duprofile.settings2);
                  } catch {
                    d.duprofile.settings2 = {};
                  }

                if (d.duprofile.settings3 && (typeof d.duprofile.settings3 === "string" || d.duprofile.settings3 instanceof String)) {
                  try {
                    d.duprofile.settings3 = JSON.parse(d.duprofile.settings3);
                  } catch {
                    d.duprofile.settings3 = {};
                  }
                }
                Object.defineProperty(d, "lastTalkDate", {
                  get() {
                    return d.duprofile.lastOnline;
                  },
                  set(val) {
                    d.duprofile.lastOnline = val;
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (TR.Locale != Translation.bg.Locale) {
                if (d.settings1) {
                  if (typeof d.settings1 === "string" || d.settings1 instanceof String) {
                    try {
                      d.settings1 = JSON.parse(d.settings1);
                    } catch {
                      d.settings1 = {};
                    }
                  }
                } else {
                  d.settings1 = {};
                }
              }
              if (d.Name === undefined) {
                Object.defineProperty(d, "Name", {
                  get() {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.Name ? d.duprofile.settings1.Name : d.devName ?? d.sn;
                  },
                  set(val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.Name = val;
                    } else {
                      //else if (d.devName) {
                      d.devName = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }

              //TODO observerComment?
              if (d.Comment === undefined) {
                Object.defineProperty(d, "Comment", {
                  get: function () {
                    return d.duprofile && d.duprofile.cuComment ? d.duprofile.cuComment : "";
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      d.duprofile.cuComment = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }

              if (d.IsFuvas && !d.IsOldFuvas && d.TelemetryProducts === undefined) {
                Object.defineProperty(d, "TelemetryProducts", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.TelemetryProducts ? d.duprofile.settings1.TelemetryProducts : [];
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.TelemetryProducts = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (d.IsFuvas && !d.IsOldFuvas && d.TelemetryIngredients === undefined) {
                Object.defineProperty(d, "TelemetryIngredients", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.TelemetryIngredients ? d.duprofile.settings1.TelemetryIngredients : [];
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.TelemetryIngredients = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }

              if (d.IsBlockedChecked === undefined) {
                Object.defineProperty(d, "IsBlockedChecked", {
                  get: function () {
                    try {
                      return d.duprofile ? d.duprofile.settings1.IsBlockedChecked : d.settings1 ? d.settings1.IsBlockedChecked : false;
                    } catch {
                      return null;
                    }
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.IsBlockedChecked = val;
                    } else if (d.settings1) {
                      d.settings1.IsBlockedChecked = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              // if (d.IsBlocked && d.IsBlockedChecked === undefined) {
              //   d.IsBlockedChecked = false;
              // }
              if (d.IsFMNearFull === undefined) {
                Object.defineProperty(d, "IsFMNearFull", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.IsFMNearFull;
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.IsFMNearFull = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (d.IsFMFull === undefined) {
                Object.defineProperty(d, "IsFMFull", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.IsFMFull;
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.IsFMFull = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (TR.Locale == Translation.bg.Locale) {
                if (d.IsFMEventChecked === undefined) {
                  Object.defineProperty(d, "IsFMEventChecked", {
                    get: function () {
                      if (d.duprofile) {
                        return d.duprofile.settings1 && d.duprofile.settings1.IsFMEventChecked;
                      } else if (d.settings1) {
                        return d.settings1.IsFMEventChecked;
                      } else return false;
                    },
                    set: function (val) {
                      if (d.duprofile) {
                        if (!d.duprofile.settings1) {
                          d.duprofile.settings1 = {};
                        }
                        d.duprofile.settings1.IsFMEventChecked = val;
                      } else if (d.settings1) {
                        d.settings1.IsFMEventChecked = val;
                      }
                    },
                    configurable: true,
                    enumerable: true,
                  });
                }
                if ((d.IsFMNearFull || d.IsFMFull) && d.IsFMEventChecked === undefined) {
                  d.IsFMEventChecked = false;
                }
              }
              if (d.PSName === undefined) {
                Object.defineProperty(d, "PSName", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.PSName ? d.duprofile.settings1.PSName : d.settings1 && d.settings1.PSName ? d.settings1.PSName : "";
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.PSName = val;
                    } else if (d.settings1) {
                      d.settings1.PSName = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (d.IsFuvas && !d.IsOldFuvas && d.TelemetryScheduleId === undefined) {
                Object.defineProperty(d, "TelemetryScheduleId", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.TelemetryScheduleId != undefined ? d.duprofile.settings1.TelemetryScheduleId : null;
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.TelemetryScheduleId = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (TR.Locale == Translation.bg.Locale) {
                if (d.MaintenanceScheduleId === undefined) {
                  Object.defineProperty(d, "MaintenanceScheduleId", {
                    get: function () {
                      return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.MaintenanceScheduleId != undefined ? d.duprofile.settings1.MaintenanceScheduleId : null;
                    },
                    set: function (val) {
                      if (d.duprofile) {
                        if (!d.duprofile.settings1) {
                          d.duprofile.settings1 = {};
                        }
                        d.duprofile.settings1.MaintenanceScheduleId = val;
                      }
                    },
                    configurable: true,
                    enumerable: true,
                  });
                }
                if (d.MaintenanceSchedule === undefined) {
                  Object.defineProperty(d, "MaintenanceSchedule", {
                    get: function () {
                      var scheds = DataManager.data[DataManager.DataType.user.dataid].settings2.maintenanceschedules.map((item) => ({
                        ...item,
                        toString: function () {
                          return item.join(", ");
                        },
                      }));
                      //return d.MaintenanceScheduleId != undefined && d.MaintenanceScheduleId != null && scheds.length > d.MaintenanceScheduleId ? scheds[d.MaintenanceScheduleId] : null;
                      return d.MaintenanceScheduleId != undefined && d.MaintenanceScheduleId != null ? scheds[d.MaintenanceScheduleId] : null;
                    },
                    configurable: true,
                    enumerable: true,
                  });
                }
              }
              if (d.TechnicianId === undefined) {
                Object.defineProperty(d, "TechnicianId", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.TechnicianId != undefined ? d.duprofile.settings1.TechnicianId : d.settings1 && d.settings1.TechnicianId != null ? d.settings1.TechnicianId : null;
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.TechnicianId = val;
                    } else if (d.settings1) {
                      d.settings1.TechnicianId = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (d.Technician === undefined) {
                Object.defineProperty(d, "Technician", {
                  get: function () {
                    var techs = DataManager.data[DataManager.DataType.user.dataid].settings2.technicians;
                    return d.TechnicianId != undefined && d.TechnicianId != null && techs.length > d.TechnicianId ? techs[d.TechnicianId] : null;
                  },
                  set: function (val) {
                    if (!val) {
                      if (d.duprofile && d.duprofile.settings1) {
                        d.duprofile.settings1.TechnicianId = null;
                      } else if (d.settings1) {
                        d.settings1.TechnicianId = null;
                      }
                    } else {
                      var idx = DataManager.data[DataManager.DataType.user.dataid].settings2.technicians.indexOf(val);
                      if (d.duprofile && idx != undefined && idx > -1) {
                        if (!d.duprofile.settings1) {
                          d.duprofile.settings1 = {};
                        }
                        d.duprofile.settings1.TechnicianId = idx;
                      } else if (d.settings1 && idx != undefined && idx > -1) {
                        d.settings1.TechnicianId = idx;
                      }
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (d.IsForMe === undefined) {
                Object.defineProperty(d, "IsForMe", {
                  get: function () {
                    return DataManager.currentTechnician == null || d.Technician == DataManager.currentTechnician;
                  },
                  configurable: false,
                  enumerable: true,
                });
              }

              if (d.IsSubscribed === undefined) {
                Object.defineProperty(d, "IsSubscribed", {
                  get: function () {
                    return d.duprofile && d.duprofile.csubscriptionPlan && d.duprofile.csubscriptionPlan.id > -1;
                  },
                  configurable: true,
                  enumerable: true,
                });
              }

              if (d.AddressLatLng === undefined) {
                Object.defineProperty(d, "AddressLatLng", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.AddressLatLng ? d.duprofile.settings1.AddressLatLng : d.settings1 && d.settings1.AddressLatLng ? d.settings1.AddressLatLng : null;
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.AddressLatLng = val;
                    } else if (d.settings1) {
                      d.settings1.AddressLatLng = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              }
              if (d.AddressLast === undefined) {
                Object.defineProperty(d, "AddressLast", {
                  get: function () {
                    return d.duprofile && d.duprofile.settings1 && d.duprofile.settings1.AddressLast ? d.duprofile.settings1.AddressLast.replace('"', "") : d.settings1 && d.settings1.Address ? d.settings1.Address.replace('"', "") : null;
                  },
                  set: function (val) {
                    if (d.duprofile) {
                      if (!d.duprofile.settings1) {
                        d.duprofile.settings1 = {};
                      }
                      d.duprofile.settings1.AddressLast = val;
                    }
                  },
                  configurable: true,
                  enumerable: true,
                });
              } else {
                //TODO Гальо парсфикс
                try {
                  d.AddressLast = d.AddressLast.replace('"', "");
                } catch {
                  /** */
                }
              }

              d.LastTelemetry = DataManager.device_last_telemetry[d.sn];
              d.LastTelemetryManual = DataManager.device_last_telemetry_manual[d.sn];
              d.LastTelemetryCalculated = DataManager.device_last_telemetry_calculated[d.sn];
              d.LastReceipt = DataManager.device_last_row[d.sn];
              if (d.duprofile && DataManager.device_last_online[d.sn] && DataManager.device_last_online[d.sn] > d.lastTalkDate) {
                d.lastTalkDate = DataManager.device_last_online[d.sn];
              }
              d.IsBlocked =
                (d.LastReceipt &&
                  d.LastReceipt.ReceiptType == ReceiptType.fuvasAction &&
                  d.LastReceipt.freeTexts &&
                  d.LastReceipt.freeTexts.length > 0 &&
                  (d.LastReceipt.freeTexts[0].trim().toLowerCase().indexOf("servi") > -1 || d.LastReceipt.freeTexts[0].trim().toLowerCase().indexOf("блок") > -1)) == true;

              if (d.duprofile && d.duprofile.zRcvdTo) {
                d.IsFMFull = d.duprofile.zRcvdTo == 2000;
                d.IsFMNearFull = d.duprofile.zRcvdTo > 1949 && !d.IsFMFull;
              }
              if (!d.IsFMFull && !d.IsFMNearFull) {
                d.IsFMEventChecked = false;
              }
              if (d.IsBlocked) {
                d.Status = DevStatus.Blocked;
              }
              //  else if (d.IsFMFull) {
              //   d.Status = DevStatus.FMFull;
              // } else if (d.IsFMNearFull) {
              //   d.Status = DevStatus.FMNearFull;
              // }
              else if (d.duprofile) {
                if (d.duprofile.cosmosableDevice) {
                  if (d.IsSubscribed) {
                    if (d.duprofile.isOnline) d.Status = DevStatus.Online;
                    else d.Status = DevStatus.Offline;
                  } else {
                    d.Status = DevStatus.NoSubscription;
                  }
                } else {
                  d.Status = DevStatus.OldDevice;
                }
              } else {
                if (TR.Locale == Translation.bg.Locale) {
                  d.Status = DevStatus.NoProfile;
                } else {
                  //TODO REMOVE
                  if (d.lastTalkDate && d.lastTalkDate.addHours(6) > new Date()) {
                    d.Status = DevStatus.Online;
                  } else {
                    d.Status = DevStatus.Offline;
                  }
                }
              }
              d.toString = function () {
                return this.Name ?? this.sn;
              };
              if (!DataManager.device_weekly_turnover[d.sn]) {
                DataManager.device_weekly_turnover[d.sn] = 0;
              }
              if (!DataManager.device_daily_turnover[d.sn]) {
                DataManager.device_daily_turnover[d.sn] = 0;
              }
              d.WeeklyTurnover = DataManager.device_weekly_turnover[d.sn];
              d.DailyTurnover = DataManager.device_daily_turnover[d.sn];
              d.ZReportReceived = DataManager.device_with_z_report_3_days[d.sn] ?? false;
              resolve(d);
            }),
          );
        });
        await Promise.all(proms).then(() => {
          if (SHOW_DEBUG_MESSAGES) {
            console.log("__fixData start sort devs");
          }
          DataManager.data[DataManager.DataType.devices.dataid].sortBy("Name");
          if (SHOW_DEBUG_MESSAGES) {
            console.log("__fixData end sort devs");
          }
          bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.devices);
        });
        if (DataManager.isVeryBigUser()) {
          DataManager.daysForRequestS = 1;
          //DataManager.daysForRequestM = ((new Date().getTime() - new Date(new Date().getFullYear() - 1, 0, 1, 0, 0, 0).getTime()) / (1000 * 60 * 60 * 24)).roundTo(0); // две години
          DataManager.daysForRequestM = ((new Date().getTime() - new Date(new Date().getFullYear(), 0, 1, 0, 0, 0).getTime()) / (1000 * 60 * 60 * 24)).roundTo(0); // от началото на годината
          console.log("DAYS FOR REQUEST M : " + DataManager.daysForRequestM);
          //DataManager.DataType.monthly.require_choice = true;
          //DataManager.DataType.monthly.initial = false;
          DataManager.DataType.monthly.load_days = DataManager.daysForRequestM;
        }
        break;

      case DataManager.DataType.daily:
      case DataManager.DataType.daily_reports:
      case DataManager.DataType.daily_reports_grouped:
      case DataManager.DataType.monthly:
        if (DataManager.data[datatype.dataid].length > 0 && DataManager.data[datatype.dataid][0].date != undefined) {
          DataManager.data[datatype.dataid].forEach((row) => {
            if (row.IsProcessed) {
              row.IsNew = false;
              return;
            }

            const data = DataManager.data[datatype.dataid];
            const shouldRemoveDuplicate =
              datatype == DataManager.DataType.monthly &&
              TR.Locale == Translation.ro.Locale &&
              row.fm &&
              data.some((rr) => rr !== row && rr.date.getTime() === row.date.getTime() && rr.sn === row.sn && rr.num === row.num && rr.fm && rr.fm.startsWith(row.fm + "_"));
            if (row.error || shouldRemoveDuplicate) {
              const idx = data.indexOf(row);

              if (idx !== -1) {
                data.splice(idx, 1);
              }
              return;
            }

            // if (
            //   row.error
            //   ||
            //   //IGNAT fix задвоени неща
            //   (datatype == DataManager.DataType.monthly &&
            //     TR.Locale == Translation.ro.Locale &&
            //     DataManager.data[datatype.dataid].find((rr) => row.date.getTime() == rr.date.getTime() && row.sn == rr.sn && rr.num == row.num && rr.fm && row.fm && rr.fm.startsWith(row.fm + "_"))
            //   )
            // ) {
            //   DataManager.data[datatype.dataid].splice(DataManager.data[datatype.dataid].indexOf(row), 1);
            //   return;
            // }
            row.Device = DataManager.data[DataManager.DataType.devices.dataid].find((d) => d.sn === row.sn);
            row.MM = row.date.getMonth();
            row.Month = DataManager.MonthNames[row.MM];
            row.YY = row.date.getFullYear();
            if (TR.Locale == Translation.bg.Locale) {
              row.Currency = row.date.getTime() > g_euroDate.getTime() ? TR.MoneyAbbreviation : TR.MoneyAbbreviation2;
            }
            row.MonthYY = row.Month + " " + row.YY;
            row.WW = row.date.getWeekOfMonth();
            row.DWT = row.date.getDateWithoutTime();
            row.DWTT = row.DWT.getTime();
            row.MONDAY = row.DWT.getMonday();
            row.WeekDay = DataManager.WeekDays[row.date.getDay()];
            row.Sum = 0;
            row.SumStorno = 0;
            if (!row.fm) {
              row.fm = row.Device.fm;
            }
            if (!row.taxGrTurnovers) {
              row.taxGrTurnovers = [];
            }
            if (!row.taxGrTurnoversStorno) {
              row.taxGrTurnoversStorno = [];
            }
            for (var i = 0; i < TR.VAT_GROUP_COUNT; i++) {
              var found = row.taxGrTurnovers.find((g) => g.tg == VAT_GROUPS[i]);
              if (found) {
                row.Sum += found.turnover;
                row["Turnover" + VAT_GROUPS[i]] = found.turnover;
              } else {
                row.taxGrTurnovers.push({ tg: VAT_GROUPS[i], turnover: 0 });
                row["Turnover" + VAT_GROUPS[i]] = 0;
              }
              var foundSt = row.taxGrTurnoversStorno.find((g) => g.tg == VAT_GROUPS[i]);
              if (foundSt) {
                row.SumStorno += foundSt.turnover;
                row["StornoTurnover" + VAT_GROUPS[i]] = foundSt.turnover;
              } else {
                row.taxGrTurnoversStorno.push({
                  tg: VAT_GROUPS[i],
                  turnover: 0,
                });
                row["StornoTurnover" + VAT_GROUPS[i]] = 0;
              }
            }
            if (!row.pmtTurnovers) {
              row.pmtTurnovers = [];
            }
            if (row.Device.IsFuvas && row.pmtTurnovers.length > 0) {
              row.Device.HasCardPayment = true;
            }
            var p1 = row.pmtTurnovers.find((g) => g.num == 1);
            var p2 = row.pmtTurnovers.find((g) => g.num == (row.Device.IsFuvas ? 2 : 7));
            row["Payment1"] = p1 ? p1.turnover : 0;
            row["Payment2"] = p2 ? p2.turnover : 0;

            if (datatype.initial && datatype == DataManager.DataType.daily) {
              DataManager.device_with_z_report_3_days[row.Device.sn] = row.date.addDays(3).getTime() > new Date().getTime();

              if (row.MONDAY.getTime() == monday.getTime() && row.date.getTime() < today) {
                DataManager.device_weekly_turnover[row.Device.sn] += row.Sum;
              }
              if (TR.Locale == Translation.ro.Locale && row.zRepNumSentToNRA !== undefined) {
                row.Device.LastZReportSentToNRA = row.zRepNumSentToNRA;
              }
            } else if (TR.Locale == Translation.ro.Locale && datatype == DataManager.DataType.daily_reports) {
              row.SentToNRA = row.num > row.Device.LastZReportSentToNRA ? "" : TR.Yes;
            }

            row.Sum = row.Sum.roundTo(2);
            row.SumStorno = row.SumStorno.roundTo(2);
            row.IsProcessed = true;
          });
          DataManager.data[datatype.dataid].sortBy("date");
        }
        bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, datatype);
        break;

      case DataManager.DataType.sales:
      case DataManager.DataType.sales_reports:
      case DataManager.DataType.invoices_reports:
      case DataManager.DataType.sales_by_articles:
      case DataManager.DataType.sales_by_article_price:
      case DataManager.DataType.sales_by_hours_qty:
      case DataManager.DataType.sales_by_hours_price:
      case DataManager.DataType.sales_by_payments:
      case DataManager.DataType.sales_last_only:
      case DataManager.DataType.telemetry:
        if (DataManager.data[datatype.dataid].length > 0 && DataManager.data[datatype.dataid][0].rcp.date != undefined) {
          if (datatype == DataManager.DataType.sales) {
            DataManager.data[DataManager.DataType.sales.dataid]
              .filter((r) => r.IsProcessed && r.IsNew)
              .forEach((row) => {
                row.IsNew = false;
              });
            Object.values(DataManager.device_last_row).forEach((v) => (v.IsNew = false));
          }
          // DataManager.date_downloaded_to[DataManager.DataType.sales.dataid] = DataManager.date_downloaded_to[type.dataid];
          // DataManager.date_downloaded_to[DataManager.DataType.sales_by_articles.dataid] = DataManager.date_downloaded_to[type.dataid];
          // DataManager.date_downloaded_to[DataManager.DataType.sales_by_hours_qty.dataid] = DataManager.date_downloaded_to[type.dataid];
          // DataManager.date_downloaded_to[DataManager.DataType.sales_by_payments.dataid] = DataManager.date_downloaded_to[type.dataid];
          // DataManager.date_downloaded_to[DataManager.DataType.telemetry_current.dataid] = DataManager.date_downloaded_to[type.dataid];
          // DataManager.data[DataManager.DataType.sales_by_articles.dataid]
          //   .filter((r) => r.IsProcessed && r.IsNew)
          //   .forEach((row) => {
          //     row.IsNew = false;
          //   });
          // DataManager.data[DataManager.DataType.sales_by_hours_qty.id]
          //   .filter((r) => r.IsProcessed && r.IsNew)
          //   .forEach((row) => {
          //     row.IsNew = false;
          //   });
          // DataManager.data[DataManager.DataType.sales_by_payments.id]
          //   .filter((r) => r.IsProcessed && r.IsNew)
          //   .forEach((row) => {
          //     row.IsNew = false;
          //   });

          await DataManager.data[datatype.dataid]
            .filter((r) => !r.IsProcessed)
            .asyncForEach((row) => {
              proms.push(
                new Promise((resolve) => {
                  // setTimeout(() => {
                  if (
                    row.error
                    //IGNAT fix задвоени неща
                    // || (TR.Locale == Translation.ro.Locale &&
                    //   DataManager.data[datatype.dataid].find(
                    //     (rr) => rr.rcp && row.rcp && row.rcp.date.getTime() == rr.rcp.date.getTime() && row.sn == rr.sn && rr.rcp.rcpNum == row.rcp.rcpNum && rr.rcp.zrepNum == row.rcp.zrepNum && rr.fm && row.fm && rr.fm.startsWith(row.fm + "_"),
                    //   ))
                  ) {
                    DataManager.data[datatype.dataid].splice(DataManager.data[datatype.dataid].indexOf(row), 1);
                    resolve();
                    return;
                  }
                  row.IsProcessed = true;
                  row.IsNew = row.rcp.date.getTime() > today.getTime(); // true;
                  row.Device = DataManager.data[DataManager.DataType.devices.dataid].find((d) => d.sn === row.sn);

                  row.ReceiptType = ReceiptTypeArray.find((f) => f.Value === row.rcp.rcpTypeCode);

                  if (SHOW_DEBUG_MESSAGES && !row.ReceiptType) {
                    console.log("__fixData failed, invalid receipt type!");
                    console.log(JSON.stringify(row.rcp));
                  }
                  row.YY = row.rcp.date.getFullYear();
                  row.MM = row.rcp.date.getMonth();
                  row.Month = DataManager.MonthNames[row.MM];
                  row.WW = row.rcp.date.getWeekOfMonth();
                  row.HH = row.rcp.date.getHours();
                  row.DWT = row.rcp.date.getDateWithoutTime();
                  row.MONDAY = row.DWT.getMonday();
                  row.DWTT = row.DWT.getTime();
                  row.date = row.rcp.date;
                  row.Sum = row.ttlSum.roundTo(2);
                  row.ItemsCount = 0;
                  if (row.ReceiptType && row.ReceiptType.IsNegative) {
                    row.Sum = -row.Sum; //TODO негатив и на плащанията и на продажбите ?
                  }
                  if (!row.finalSum) {
                    //TODO Тошо как ще кръсти новото поле
                    row.finalSum = row.Sum;
                  }
                  if (datatype.initial) {
                    if (!datatype.LastOnly && !row.rcp.void && row.MONDAY.getTime() == monday.getTime()) {
                      DataManager.device_weekly_turnover[row.Device.sn] += row.finalSum; // row.Device.WeeklyTurnover += row.Sum;
                      if (row.DWT.getTime() == today.getTime()) {
                        DataManager.device_daily_turnover[row.Device.sn] += row.finalSum; //row.Device.DailyTurnover += row.Sum;
                      }
                    }
                    if (row.dateReceived && (!row.Device.lastTalkDate || row.dateReceived > row.Device.lastTalkDate)) {
                      row.Device.lastTalkDate = row.dateReceived;
                      DataManager.device_last_online[row.Device.sn] = row.dateReceived;
                    }
                    DataManager.device_last_row[row.Device.sn] = row;
                  }
                  row.Device.LastReceipt = DataManager.device_last_row[row.Device.sn];

                  //TODO без войдираните бонове?
                  if (!datatype.LastOnly && datatype.id != DataManager.DataType.sales_reports.id && datatype.id != DataManager.DataType.sales.id) {
                    var idx = DataManager.data[datatype.dataid].indexOf(row);
                    DataManager.data[datatype.dataid].splice(idx, 1);
                    // DataManager.data[DataManager.DataType.sales_reports.dataid].push(row);
                  }

                  if (row.Device.IsFuvas) {
                    // IsOldFuvas ???
                    if (row.ReceiptType == ReceiptType.fiscalReceipt) {
                      if (!row.sales) {
                        row.sales = [
                          {
                            num: 1,
                            name: "Vending",
                            qty: 1,
                            price: row.finalSum,
                            sum: row.finalSum,
                            finalPrice: row.finalSum,
                            taxGr: VAT_GROUPS[1],
                            vatPrc: 20,
                            void: false,
                            type: "Art",
                            typeCode: 49,
                          },
                        ];
                      }
                      // if (!row.taxGrSums) {
                      //   row.taxGrSums = [
                      //     {
                      //       taxGr: VAT_GROUPS[1],
                      //       vatPrc: 20,
                      //       vat: ((row.finalSum * 20) / 100).roundTo(2), //TODO WRONG?!
                      //       sum: row.finalSum,
                      //     },
                      //   ];
                      // }
                      if (!row.operator) {
                        row.operator = { name: TR.Operator + " 1", num: 1 };
                      }
                      if (!row.payments) {
                        row.payments = [{ sum: row.finalSum, payType: TR.InCash.padEnd(10).substring(0, 9) }];
                      }
                    } else if ((row.ReceiptType == ReceiptType.telemetry || row.ReceiptType == ReceiptType.telemetry_manual) && row.freeTexts.length > 1) {
                      if (datatype.initial) {
                        if (row.ReceiptType == ReceiptType.telemetry) {
                          DataManager.userHasTelemetry = true;
                          DataManager.userType |= DataManager.UserTypes.OwnerWithTelemetry;
                          row.Device.LastTelemetry = row;
                          if (row.Device.LastTelemetryManual) {
                            row.Device.LastTelemetryCalculated = Telemetry.ComputeTelemetry(new Telemetry(row.date, row.freeTexts, row.Device), new Telemetry(row.Device.LastTelemetryManual.date, row.Device.LastTelemetryManual.freeTexts, row.Device));
                          }
                        } else if (row.ReceiptType == ReceiptType.telemetry_manual) {
                          DataManager.userHasTelemetry = true;
                          DataManager.userType |= DataManager.UserTypes.OwnerWithTelemetry;
                          row.Device.LastTelemetryManual = row;
                          row.Device.LastTelemetryCalculated = Telemetry.ComputeTelemetry(new Telemetry(row.date, row.freeTexts, row.Device), new Telemetry(row.date, row.freeTexts, row.Device));
                        }
                        if (row.Device.LastTelemetryCalculated) {
                          var telemetryO = Object.assign({}, row.Device);
                          telemetryO.LastTelemetryCalculated.Products.forEach((p) => (telemetryO["TelemetryProductSoldQuantity" + p.Identifier] = p.NumberOfPaidProductsVendedSinceInit));
                          var ffIdx = DataManager.data[DataManager.DataType.telemetry_current.dataid].findIndex((d) => d.sn == row.Device.sn);
                          if (ffIdx == -1) {
                            DataManager.data[DataManager.DataType.telemetry_current.dataid].push(telemetryO);
                          } else {
                            DataManager.data[DataManager.DataType.telemetry_current.dataid][ffIdx] = telemetryO;
                          }
                        }
                      }
                    }
                  }
                  if (!datatype.initial) {
                    if (datatype == DataManager.DataType.sales_by_articles || datatype == DataManager.DataType.sales_by_article_price || datatype == DataManager.DataType.sales_by_hours_qty || datatype == DataManager.DataType.sales_by_hours_price) {
                      if (row.sales && row.sales.length > 0 && !row.rcp.void) {
                        //row.ItemsQty = row.sales.map((c) => c.qty).sum(); //TODO без войдираните артикули?
                        row.ItemsCount = row.sales.length; //TODO без войдираните артикули? //горния ред беше по количества, този е по брой транзакции
                        Array.extendByProp(row, "sales").forEach((sr) => {
                          var cloneRow = Object.assign({}, sr);

                          if (cloneRow.ReceiptType && (cloneRow.ReceiptType.IsNegative || !!cloneRow["sales_void"])) {
                            cloneRow["sales_qty"] *= -1;
                            cloneRow["sales_sum"] *= -1;
                          }

                          // if (cloneRow["sales_name"] == "Закуска на майстора") {
                          //   // if (cloneRow["sales_finalPrice"] != cloneRow["sales_sum"])
                          //   // if ((cloneRow["sales_finalPrice"] /1.6 %1) ) {
                          //   // console.log(cloneRow.rcp.rcpNum +": " + cloneRow["sales_qty"] + " * " + cloneRow["sales_sum"] + " = " +cloneRow["sales_finalPrice"]);
                          //   if (cloneRow.rcp.rcpNum == 223968 || cloneRow.rcp.rcpNum == 103727) {
                          //     console.log(cloneRow)
                          //   }
                          //   // console.log(cloneRow.rcp.rcpNum)
                          // }
                          DataManager.data[datatype.dataid].push(cloneRow);
                        });
                      }
                    } else if (datatype == DataManager.DataType.sales_by_payments && row.payments && row.payments.length > 0 && !row.rcp.void) {
                      Array.extendByProp(row, "payments").forEach((sr) => {
                        var nn = Object.assign({}, sr);
                        nn.date = nn.date.getDateWithoutTime();
                        DataManager.data[DataManager.DataType.sales_by_payments.dataid].push(nn);
                      });
                    } else if (datatype == DataManager.DataType.invoices_reports) {
                      if (row.ReceiptType == ReceiptType.invoice || row.ReceiptType == ReceiptType.creditNote) {
                        if (!row.taxGrSums) {
                          row.taxGrSums = [];
                        }
                        for (var i = 0; i < TR.VAT_GROUP_COUNT; i++) {
                          var found = row.taxGrSums.find((g) => g.taxGr == VAT_GROUPS[i]);
                          if (found) {
                            if (row.ReceiptType.IsNegative) {
                              row["Turnover" + VAT_GROUPS[i]] = -found.sum;
                              row["VAT" + VAT_GROUPS[i]] = -found.vat;
                            } else {
                              row["Turnover" + VAT_GROUPS[i]] = found.sum;
                              row["VAT" + VAT_GROUPS[i]] = found.vat;
                            }
                          } else {
                            row["Turnover" + VAT_GROUPS[i]] = 0;
                            row["VAT" + VAT_GROUPS[i]] = 0;
                          }
                        }
                        var cloneRow = Object.assign({}, row);
                        DataManager.data[DataManager.DataType.invoices_reports.dataid].push(cloneRow);
                      }
                    } else if (datatype == DataManager.DataType.sales_reports) {
                      if (!row.taxGrSums) {
                        row.taxGrSums = [];
                      }
                      for (var tg = 0; tg < TR.VAT_GROUP_COUNT; tg++) {
                        var foundTg = row.taxGrSums.find((g) => g.taxGr == VAT_GROUPS[tg]);
                        if (foundTg) {
                          if (row.ReceiptType && row.ReceiptType.IsNegative) {
                            row["Turnover" + VAT_GROUPS[tg]] = -foundTg.sum;
                            row["VAT" + VAT_GROUPS[tg]] = -foundTg.vat;
                          } else {
                            row["Turnover" + VAT_GROUPS[tg]] = foundTg.sum;
                            row["VAT" + VAT_GROUPS[tg]] = foundTg.vat;
                          }
                        } else {
                          row["Turnover" + VAT_GROUPS[tg]] = 0;
                          row["VAT" + VAT_GROUPS[tg]] = 0;
                        }
                      }
                    }
                  }

                  resolve();
                  // }, 0);
                }),
              );
            });
          await Promise.all(proms).then(async () => {
            DataManager.data[DataManager.DataType.sales_reports.dataid].sortBy("date");
            await DataManager.__fixData(DataManager.DataType.devices);
            if (!DataManager.___demoMode) {
              await DataManager.__fixData(DataManager.DataType.telemetry_current);
            }
            bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, datatype);
          });
          if (SHOW_DEBUG_MESSAGES) {
            console.log("__fixData sales end");
          }
        } else {
          if (SHOW_DEBUG_MESSAGES) {
            console.log("no data " + datatype.name);
          }
        }
        break;

      case DataManager.DataType.messages:
        DataManager.data[datatype.dataid].sortByDesc("dateAdded");
        bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.messages);
        break;

      case DataManager.DataType.telemetry_current:
        var devsWT = DataManager.getData(DataManager.DataType.devices, true).filter((d) => d.LastTelemetryCalculated);
        if (devsWT.length > 0) {
          var maxProdQtyCount = Math.max(...devsWT.map((d) => Math.max(...d.LastTelemetryCalculated.Products.map((p) => p.Identifier))));

          // DataManager.data[DataManager.DataType.telemetry_current.dataid].forEach(p => {
          //   var i = maxProdQtyCount;
          //   while (p.Device["TelemetryProductSoldQuantity" + i] === undefined && i > 0) {
          //     p.Device["TelemetryProductSoldQuantity" + i] = 0;
          //     i--;
          //   }
          // })
          var idx = 1;
          var lastHeader = DataManager.headers[DataManager.DataType.telemetry_current.id][DataManager.headers[DataManager.DataType.telemetry_current.id].length - 1];
          if (lastHeader.value.startsWith("TelemetryProductSoldQuantity")) {
            idx = Number(lastHeader.value.replace("TelemetryProductSoldQuantity", "")) + 1;
          }
          for (; idx <= maxProdQtyCount; idx++) {
            DataManager.headers[DataManager.DataType.telemetry_current.id].push(new DataHeader("Пр." + idx, "TelemetryProductSoldQuantity" + idx, DataPropType.Number, "end", false, true));
          }
          // DataManager.props_for_summing[DataManager.DataType.telemetry_current.id] = [];
          // for (var i = 1; i < maxProdQtyCount; i++) {
          //   DataManager.props_for_summing[DataManager.DataType.telemetry_current.id].push("TelemetryProductSoldQuantity" + i)
          // }
        }
        bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, DataManager.DataType.telemetry_current);
        break;

      default:
        bus.$emit(bus.EVENT_DataManager_DATA_CHANGED, datatype);
        break;
    }
    if (SHOW_DEBUG_MESSAGES) {
      console.log("__fixData end " + datatype.name);
    }
  }
}

function reviver(key, value) {
  if (typeof value === "string" && (dateFormat.test(value) || dateFormat2.test(value))) {
    return new Date(value);
  }
  return value;
}

export default DataManager;
